// ActivityToPDFConverter.js
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { jsPDF } from 'jspdf';
import { Table } from "reactstrap";
import awicon from "../../assets/images/services-icon/coin.png"
import { SECURITY_KEY, BASE_URL } from "../../global"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Input,
} from "reactstrap"
import "./custom.css"
import { MathJax, MathJaxContext } from "better-react-mathjax"
import html2pdf from 'html2pdf.js';


const ActivityToPDFConverter = forwardRef(({ ActivityData, type, name = null, other = null}, ref) => {
  const contentRef = useRef();

  useImperativeHandle(ref, () => ({
    async generatePDF() {

    const container = contentRef.current;

    if (!container) return;

      // 1) Tag each question wrapper
      container.querySelectorAll('.hw-list').forEach(el => {
        el.classList.add('no-break');
      });

      // 2) Wait for images & DOM flush as before
      const images = [...container.querySelectorAll('img')];
      await Promise.all(
        images.map(img => {
          const src = img.src;
          img.classList.add('avoid-break');
          if (/^https?:\/\//.test(src)) {
            img.src = `${BASE_URL}image-proxy?url=${encodeURIComponent(src)}`;
          }
          return img.complete
            ? Promise.resolve()
            : new Promise(res => { img.onload = img.onerror = res });
        })
      );
      await new Promise(r => setTimeout(r, 100));

    // 3) HTML → PDF via html2pdf.js
      const opt = {
        margin:       50,
        filename:     'activity-details.pdf',
        html2canvas: {
          // render at twice (or more!) the screen density
          scale: 1,
          useCORS:  true,
          allowTaint: true,
          dpi:   60,             // for good measure
          letterRendering: true,
        },
        image: {
          type:    'png',
          quality: 1.0,              // max quality
        },
        jsPDF:        {
          unit:     'pt',
          format:   'a4',
          orientation: 'portrait',
        },
        pagebreak:    {
          mode:  ['avoid-all','css','legacy'],
          avoid: ['.no-break'],
        },
      };

      // clone it if you’re worried about mutating the live DOM
      html2pdf().set(opt).from(container).save();
    }
  }));

// useImperativeHandle(ref, () => ({
//   async generatePDF() {
//     const container = contentRef.current;
//     if (!container) return;

//     const clonedContainer = container.cloneNode(true);

//     // // 🔹 1. Fetch custom CSS
//     // const customCss = await fetch('/index.css')
//     //   .then((res) => res.ok ? res.text() : '')
//     //   .catch(() => '');
      

//     // // 🔹 2. Fetch Bootstrap CSS (CDN or local)
//     // const bootstrapCss = await fetch('https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css')
//     //   .then((res) => res.ok ? res.text() : '')
//     //   .catch(() => '');

//     // // 🔹 3. Inject both styles into <style> tag
//     // const styleTag = document.createElement('style');
//     // styleTag.textContent = `${bootstrapCss}\n${customCss}`;
//     // clonedContainer.insertBefore(styleTag, clonedContainer.firstChild);

//     // Replace remote images with proxied images if needed
//     const images = clonedContainer.querySelectorAll('img');
//     await Promise.all(
//       Array.from(images).map(async (img) => {
//         const src = img.getAttribute('src');
//         if (src && (src.startsWith('http://') || src.startsWith('https://'))) {
//           img.setAttribute('src', `${BASE_URL}image-proxy?url=${encodeURIComponent(src)}`);
//         }
//       })
//     );

//     // Ensure all images are loaded
//     await Promise.all(
//       Array.from(clonedContainer.querySelectorAll('img')).map((img) => {
//         if (!img.complete) {
//           return new Promise((res) => {
//             img.onload = img.onerror = res;
//           });
//         }
//       })
//     );

//     // Generate PDF
//     const opt = {
//       margin: 0.5,
//       filename: 'activity-details.pdf',
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: { scale: 1, useCORS: true },
//       jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
//       pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
//     };

//     console.log(clonedContainer)
//     html2pdf().set(opt).from(clonedContainer).save();
//   },
// }));



    if (!ActivityData) return null; // Don't render if no data

  function rearrangeEvenOddSecond(array) {
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    return rearranged // Return the final rearranged array
  }

  function rearrangeEvenOdd(array) {
    array.sort((a, b) => {
      const textA = a.english_answer_text || a.answer_text || "";
      const textB = b.english_answer_text || b.answer_text || "";
      return textA.localeCompare(textB);
    });
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    // Check if further rearrangement is needed
    if (rearranged.length > 1) {
      return rearrangeEvenOddSecond(rearranged) // Call recursively for further rearrangement
    }

    return rearranged // Return the final rearranged array
  }

    const CountTotalCoins = question => {
    let total_coins = 0

    if (question && question.length > 0) {
      question.forEach(activity => {
        if (activity.fk_sub_id === "1") {
          if (
            activity.english_question &&
            (parseInt(
              activity.english_question[0]?.english_question_category_id
            ) === 10 ||
              parseInt(
                activity.english_question[0]?.english_question_category_id
              ) === 13)
          ) {
            activity.english_question.map((question, index1) => {
              let total_part = question.english_question_parts
              let array_part_data = total_part.filter(
                part =>
                  part.english_question_answers?.length > 0 &&
                  part.english_question_answers[0]?.english_answer_text &&
                  part.english_question_answers[0]?.english_answer_text != ""
              )
              total_coins += array_part_data.length * 2 || 0
            })
          } else {
            total_coins += activity?.english_question?.reduce(
              (acc, question) =>
                acc + question?.english_question_parts?.length * 2,
              0
            )
          }
          // total_coins += activity.english_question.reduce((acc, question) => acc + question.english_question_parts.length * 2, 0);
        } else if (activity.fk_sub_id === "2" || activity.fk_sub_id === "3") {
          total_coins += activity?.question?.reduce(
            (acc, question) => acc + question?.question_parts?.length * 2,
            0
          )
        }
      })
    }
    // setTotalCoins(total_coins);
    return total_coins
  }

   const CountTotalCoinsForActivity = activityData => {
      let total_coins_stu = 0
    
    
      if (
        activityData &&  activityData.length > 0
      ) {
       
          activityData.forEach(lsquestion => {
              let questionData = lsquestion?.question_details || null;
              if (
                parseInt(lsquestion.subjectId) === 2 &&
                questionData
              ) {
                  
                total_coins_stu += questionData?.question_parts?.length * 2 || 0
                
              } else if (
                parseInt(lsquestion.subjectId) === 1 &&
                questionData 
              ) {
                // lsquestion.english_question.forEach(lsquestionParts => {
                  if (
                    parseInt(questionData?.english_question_category_id) ===
                      10 ||
                    parseInt(questionData?.english_question_category_id) === 13
                  ) {
                    let total_part = questionData.question_parts
                    let array_part_data = total_part.filter(
                      part =>
                        part.question_answers.length > 0 &&
                        part.question_answers[0].english_answer_text &&
                        part.question_answers[0].english_answer_text != ""
                    )
                    total_coins_stu += array_part_data.length * 2 || 0
                  } else {
                    total_coins_stu +=
                    questionData.question_parts.length * 2
                  }
                  // total_coins_stu += lsquestionParts.english_question_parts.length * 2;
                // })
              }
            })
         
      }
    
      return total_coins_stu;
    }
  console.log(ActivityData)
 
return type === 'page' ?
     (
        <div 
        style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '795px',       // use viewport width
                height: 'auto',
                opacity: 0,
                pointerEvents: 'none',
                zIndex: -1,              // keep it below everything
            }}
        >
            <div ref={contentRef} className="pdf-content" 
                style={{
                    display: 'block',
                    margin: '0 auto',
                    fontSize: '12px',
                    width: '100%',
                    maxWidth: '100%',
                    lineHeight: '1.4',
                }}>
            

                <div className="d-flex align-items-between w-100">
                    <div className="d-flex align-items-center justify-content-between flex-grow-1">
                        <h6 className="ms-3 font-size-20 text-black w-60 fw-regular">
                        {ActivityData && ActivityData?.activity_type === 0 && ActivityData.activity_node && ActivityData.activity_node[0]?.node_name ? ActivityData.activity_node[0].node_name : null}
                        {ActivityData && ActivityData?.activity_type === 8 && ActivityData.activity_node && ActivityData.activity_node[0]?.name ? ActivityData.activity_node[0].name : null}
                        
                        </h6>
                        <p className="mb-0 text-uppercase ">
                        {" "}
                        <span className="text-yellow me-1">
                            {ActivityData && ActivityData.subject_name
                            ? ActivityData.subject_name
                            : null}
                        </span>{" "}
                        {ActivityData?.activity_type === 8 ? "Summative" :  "Online Activities"}{" "}
                        </p>
                        <div className=" font-size-16">
                        <img width={24} className="" src={awicon} alt="" />{" "}
                        {ActivityData && ActivityData.coins_earned
                            ? ActivityData.coins_earned
                            : 0}
                        /
                        {ActivityData &&
                        ActivityData.LessonActivitiesQuestions &&
                        ActivityData.LessonActivitiesQuestions.length > 0
                            ? CountTotalCoins(ActivityData.LessonActivitiesQuestions)
                            : 0}{" "}
                        coins earned
                        </div>
                    </div>
                </div>
                {ActivityData &&
                    ActivityData.LessonActivitiesQuestions &&
                    ActivityData.LessonActivitiesQuestions.length > 0
                        ? ActivityData.LessonActivitiesQuestions.map(
                            (ActivityData1, activeindex) => {
                            if (
                                ActivityData1.english_question &&
                                ActivityData1.english_question.length > 0 &&
                                parseInt(ActivityData1.fk_sub_id) === 1
                            ) {
                                return ActivityData1.english_question.map(
                                (InnerActivityData, index) => {
                                    if (index === 0) {
                                    if (
                                        InnerActivityData &&
                                        InnerActivityData.english_question_category_id &&
                                        parseInt(
                                        InnerActivityData.english_question_category_id
                                        ) === 1
                                    ) {
                                        return (
                                    
                                            <div className="hw-list mt-1 pb-50 w-100">
                                            <ul className="list-unstyled mb-0 question_container">
                                                <li className="justify-content-between">
                                                <div className="d-flex align-items-start gap-4 justify-content-end">
                                                
                                                    <div className="mb-0 d-flex align-items-center gap-2">
                                                    <h6 className="mb-0">
                                                        #
                                                        {InnerActivityData.english_question_id
                                                        ? InnerActivityData.english_question_id
                                                        : null}
                                                    </h6>
                                                    
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-between gap-3 mb-3">
                                                <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                    __html:
                                                        InnerActivityData.english_question_text
                                                        ? InnerActivityData.english_question_text
                                                            .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                            )
                                                            .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                            )
                                                        : null,
                                                    }}
                                                ></div>
                                                    {InnerActivityData.english_question_parts &&
                                                    InnerActivityData.english_question_parts.map((quspart, index) => (
                                                        <div key={index}>
                                                        {((quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 1) || (quspart.english_question_part_automark != 1 && ActivityData1.marked_for_manual_marking == 1)) && (
                                                            quspart.markedReport && quspart.markedReport > 0 ?
                                                            <div>
                                                            {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                            <span className="badge bg-warning font-size-12 mt-auto mb-2">Override</span>
                                                            </div>
                                                            :
                                                            null
                                                            
                                                        )}
                                                        </div>
                                                    ))}
                                                </div>

                                                <ul className="dg-selector width-controll list-unstyled mb-0">
                                                    {InnerActivityData.english_question_parts &&
                                                    InnerActivityData.english_question_parts.map(
                                                        (quspart, index) => {
                                                        //const stuAnswersarray = quspart.StudentAnsAttempts.map(stuAns => stuAns.student_answer);

                                                        const stuAnswersarray =
                                                            quspart.StudentAnsAttempts.map(
                                                            stuAns => {
                                                                try {
                                                                return JSON.parse(
                                                                    stuAns.student_answer
                                                                )
                                                                } catch (error) {
                                                                console.error(
                                                                    "Error parsing JSON:",
                                                                    error
                                                                )
                                                                return null // or handle the error in an appropriate way
                                                                }
                                                            }
                                                            ) || [] // Extracting session keys

                                                        // Assuming stuAnswersarray is a nested array
                                                        const flattenedStuAnswers =
                                                            [].concat(
                                                            ...stuAnswersarray
                                                            )
                                                        let serialNumber = 0
                                                        //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                        return (
                                                            quspart.english_question_answers &&
                                                            rearrangeEvenOdd(
                                                            quspart.english_question_answers
                                                            ).map(
                                                            (qusAns, index1) => {
                                                                const cleanText =
                                                                qusAns.english_answer_text
                                                                    .replace(
                                                                    /&nbsp;/g,
                                                                    ""
                                                                    )
                                                                    .replace(/`/g, "")
                                                                    .replace(
                                                                    /<[^>]*>/g,
                                                                    ""
                                                                    )
                                                                    .trim()

                                                                const hasImage =
                                                                /<img\s+[^>]*>/gi.test(
                                                                    qusAns.english_answer_text
                                                                )

                                                                if (
                                                                !cleanText &&
                                                                !hasImage
                                                                ) {
                                                                return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                }
                                                                serialNumber++
                                                                let filteredStuAns =
                                                                flattenedStuAnswers.filter(
                                                                    stuAns =>
                                                                    parseInt(
                                                                        stuAns.part_id
                                                                    ) ===
                                                                        parseInt(
                                                                        qusAns.english_answer_part_id
                                                                        ) &&
                                                                    parseInt(
                                                                        stuAns.answer_id
                                                                    ) ===
                                                                        parseInt(
                                                                        qusAns.english_answer_id
                                                                        )
                                                                ) || []

                                                                var status_color =
                                                                "selector-general cursor-pointer"
                                                                var border_color =
                                                                "border-start-secondary"
                                                                if (
                                                                filteredStuAns.length >
                                                                0
                                                                ) {
                                                                if (
                                                                    parseInt(
                                                                    qusAns.english_answer_is_correct
                                                                    ) === 1
                                                                ) {
                                                                    status_color =
                                                                    "selector-success"
                                                                    border_color =
                                                                    "border-start-success"
                                                                } else {
                                                                    status_color =
                                                                    "selector-wrong "
                                                                    border_color =
                                                                    "border-start-danger"
                                                                }
                                                                }
                                                                //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                return (
                                                                <li
                                                                    className={
                                                                    status_color +
                                                                    " choose e_choose"
                                                                    }
                                                                    key={index1}
                                                                >
                                                                    <div className="p-2 px-3 font-size-18">
                                                                    {serialNumber}
                                                                    </div>
                                                                    <div
                                                                    className={
                                                                        "p-2 dg-media " +
                                                                        {
                                                                        border_color,
                                                                        }
                                                                    }
                                                                    dangerouslySetInnerHTML={{
                                                                        __html:
                                                                        qusAns.english_answer_text
                                                                            ? qusAns.english_answer_text
                                                                            : null,
                                                                    }}
                                                                    ></div>
                                                                </li>
                                                                )
                                                            }
                                                            )
                                                        )
                                                        }
                                                    )}
                                                </ul>
                                                
                                                </li>
                                            </ul>
                                            </div>
                                        )
                                    } else if (
                                        InnerActivityData &&
                                        InnerActivityData.english_question_category_id &&
                                        (parseInt(
                                        InnerActivityData.english_question_category_id
                                        ) === 8 ||
                                        parseInt(
                                            InnerActivityData.english_question_category_id
                                        ) === 2 ||
                                        parseInt(
                                            InnerActivityData.english_question_category_id
                                        ) === 12)
                                    ) {
                                        return (
                                    
                                            <div className="hw-list mt-1 pb-50 not_scroll w-100">
                                            <ul className="list-unstyled mb-0 question_container">
                                                <li className="justify-content-between">
                                                <div className="d-flex align-items-start gap-4 justify-content-end">
                                                  
                                                    <div className="mb-0 d-flex align-items-center gap-2">
                                                    <h6 className="mb-0">
                                                        #
                                                        {InnerActivityData.english_question_id
                                                        ? InnerActivityData.english_question_id
                                                        : null}
                                                    </h6>
                                                    
                                                    </div>
                                                </div>
                                                <div className=" mt-2">
                                                    
                                                    <div
                                                        className="mt-3"
                                                        dangerouslySetInnerHTML={{
                                                        __html:
                                                            InnerActivityData.english_question_instruction
                                                            ? InnerActivityData.english_question_instruction
                                                                .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                )
                                                                .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                )
                                                            : null,
                                                        }}
                                                    ></div>

                                                    {/* Choice */}
                                                    {InnerActivityData &&
                                                    InnerActivityData.english_question_choices &&
                                                    InnerActivityData
                                                        .english_question_choices.length >
                                                        0 ? (
                                                        <div className="mt-4 my-2 border border-dark choice-options_wrapper">
                                                        {InnerActivityData.english_question_choices.map(
                                                            (qusChoice, Cindex) => (
                                                            <div
                                                                class="choice-options_child"
                                                                key={Cindex}
                                                            >
                                                                <div>
                                                                {qusChoice.choice_no}
                                                                </div>
                                                                <div>
                                                                {qusChoice.choice_text}
                                                                </div>
                                                            </div>
                                                            )
                                                        )}
                                                        </div>
                                                    ) : null}

                                                    
                                                    {InnerActivityData.english_question_text &&
                                                    parseInt(
                                                        InnerActivityData.english_question_category_id
                                                    ) === 8 ? (
                                                        <div
                                                        className="mt-4"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                            InnerActivityData.english_question_text
                                                                ? InnerActivityData.english_question_text
                                                                    .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                    .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                    .replace(
                                                                    /&nbsp;/g,
                                                                    ""
                                                                    )
                                                                    .split("</p>")
                                                                    .map(
                                                                    (
                                                                        paragraph,
                                                                        index
                                                                    ) =>
                                                                        paragraph
                                                                        ? `<div class="d-flex"><p class="me-2">${
                                                                            index + 1
                                                                            } ${paragraph}</p></div>`
                                                                        : ""
                                                                    )
                                                                    .filter(Boolean)
                                                                    .join("")
                                                                : null,
                                                        }}
                                                        />
                                                    ) : (
                                                        <div
                                                        className="mt-4"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                            InnerActivityData.english_question_text
                                                                ? InnerActivityData.english_question_text
                                                                    .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                    .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                : null,
                                                        }}
                                                        ></div>
                                                    )}
                                                    {InnerActivityData &&
                                                    InnerActivityData.part_heading &&
                                                    InnerActivityData.part_heading !=
                                                        "" ? (
                                                        <div
                                                        className="mt-4"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                            InnerActivityData.part_heading,
                                                        }}
                                                        ></div>
                                                    ) : null}
                                                    {/* File option */}
                                                    <div className="mt-4 my-2">
                                                        {InnerActivityData &&
                                                        InnerActivityData.english_question_files &&
                                                        InnerActivityData
                                                        .english_question_files.length >
                                                        0
                                                        ? InnerActivityData.english_question_files.map(
                                                            (qusFile, imgindex) => (
                                                                <img
                                                                key={imgindex}
                                                                alt=""
                                                                style={{
                                                                    height: "auto",
                                                                    maxWidth: "100%",
                                                                }}
                                                                src={`https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/question_files/${qusFile.file_name}`}
                                                                />
                                                            )
                                                            )
                                                        : null}
                                                    </div>

                                                    

                                                    <div className="">   
                                                    {/* Past question */}
                                                    {InnerActivityData.english_question_parts &&
                                                        InnerActivityData.english_question_parts.map(
                                                        (quspart, index) => {
                                                            const stuAnswersarray =
                                                            quspart.StudentAnsAttempts.map(
                                                                stuAns => {
                                                                try {
                                                                    return JSON.parse(
                                                                    stuAns.student_answer
                                                                    )
                                                                } catch (error) {
                                                                    console.error(
                                                                    "Error parsing JSON:",
                                                                    error
                                                                    )
                                                                    return null // or handle the error in an appropriate way
                                                                }
                                                                }
                                                            ) || [] // Extracting session keys

                                                            // Assuming stuAnswersarray is a nested array
                                                            const flattenedStuAnswers =
                                                            [].concat(
                                                                ...stuAnswersarray
                                                            )
                                                            let serialNumber = 0
                                                            return (
                                                            <div key={index}>
                                                                <div class="d-flex justify-content-between gap-3 mb-3">
                                                                <div className="d-flex gap-2 flex-row ">
                                                                <div className="mr-3">
                                                                    {index + 1}
                                                                    {")"}
                                                                </div>
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        quspart.english_question_part_text
                                                                        ? quspart.english_question_part_text
                                                                            .replace(
                                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                                ""
                                                                            )
                                                                            .replace(
                                                                                /\[Answer char=\d+\]/g,
                                                                                ""
                                                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                            )

                                                                            
                                                                            // .replace(
                                                                            // /<u>(?:&nbsp;|\s)+<\/u>/g,
                                                                            // '<span style="display:inline-block;border-bottom:1px solid black;width:200px;"></span>'
                                                                            // )
                                                                        : null,
                                                                    }}
                                                                ></div>
                                                                </div>
                                                                {(quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 1) || (quspart.english_question_part_automark != 1 && ActivityData1.marked_for_manual_marking == 1) ? 
                                                                    quspart.markedReport && quspart.markedReport > 0 ?
                                                                    <div>
                                                                    {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                                    <span className="badge bg-warning font-size-12 mt-auto mb-2">Override</span>
                                                                    </div>
                                                                    :
                                                                    null
                                                                    : 
                                                                    null
                                                                }
                                                                </div>
                                                                {/* Anse category statement Star */}
                                                                {quspart.english_question_part_answer_type ===
                                                                8 ||
                                                                quspart.english_question_part_answer_type ===
                                                                1 ||
                                                                quspart.english_question_part_answer_type ===
                                                                7 ? (
                                                                <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                    
                                                                    {quspart.english_question_answers &&
                                                                    quspart.english_question_answers.map(
                                                                        (
                                                                        qusAns,
                                                                        index1
                                                                        ) => {
                                                                        // Your logic for filtering student answers and determining status_color and border_color
                                                                        const stuAnswersarray =
                                                                            quspart.StudentAnsAttempts.map(
                                                                            stuAns => {
                                                                                try {
                                                                                return JSON.parse(
                                                                                    stuAns.student_answer
                                                                                )
                                                                                } catch (error) {
                                                                                console.error(
                                                                                    "Error parsing JSON:",
                                                                                    error
                                                                                )
                                                                                return null // or handle the error in an appropriate way
                                                                                }
                                                                            }
                                                                            ) || [] // Extracting session keys
                                                                        //console.log(stuAnswersarray);
                                                                        // Assuming stuAnswersarray is a nested array
                                                                        const flattenedStuAnswers =
                                                                            [].concat(
                                                                            ...stuAnswersarray
                                                                            )
                                                                        let cleanedText =
                                                                            qusAns.english_answer_text
                                                                            .replace(
                                                                                /&nbsp;/g,
                                                                                ""
                                                                            )
                                                                            .replace(
                                                                                /`/g,
                                                                                ""
                                                                            )
                                                                            .replace(
                                                                                /<[^>]*>/g,
                                                                                ""
                                                                            ) || ""
                                                                        let resultTest =
                                                                            cleanedText
                                                                            .toLowerCase()
                                                                            .trim()
                                                                        let answers =
                                                                            resultTest.split(
                                                                            "|"
                                                                            ) || []
                                                                        let firstAnswer =
                                                                            answers[0]
                                                                            ? answers[0].trim()
                                                                            : ""
                                                                        let secondAnswer =
                                                                            answers[1]
                                                                            ? answers[1].trim()
                                                                            : ""
                                                                        let answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase()).filter(Boolean) || []; 

                                                                        if (
                                                                            qusAns.english_answer_is_correct ===
                                                                            1
                                                                        ) {
                                                                            let filteredStuAns =
                                                                            flattenedStuAnswers.filter(
                                                                                stuAns =>
                                                                                parseInt(
                                                                                    stuAns.part_id
                                                                                ) ===
                                                                                    parseInt(
                                                                                    qusAns.english_answer_part_id
                                                                                    ) &&
                                                                                (stuAns.text
                                                                                    .toLowerCase()
                                                                                    .trim() ==
                                                                                    resultTest ||
                                                                                    stuAns.text
                                                                                    .toLowerCase()
                                                                                    .trim() ==
                                                                                    firstAnswer ||
                                                                                    stuAns.text
                                                                                    .toLowerCase()
                                                                                    .trim() ==
                                                                                    secondAnswer ||
                                                                                    answersArray.some(answer => answer == stuAns.text
                                                                                        .toLowerCase()
                                                                                        .trim())) &&
                                                                                parseInt(
                                                                                    stuAns.answer_id
                                                                                ) ===
                                                                                    parseInt(
                                                                                    qusAns.english_answer_id
                                                                                    )
                                                                            ) || []

                                                                            let filteredAllStuAns =
                                                                            flattenedStuAnswers.filter(
                                                                                stuAns =>
                                                                                parseInt(
                                                                                    stuAns.part_id
                                                                                ) ===
                                                                                    parseInt(
                                                                                    qusAns.english_answer_part_id
                                                                                    ) &&
                                                                                parseInt(
                                                                                    stuAns.answer_id
                                                                                ) ===
                                                                                    parseInt(
                                                                                    qusAns.english_answer_id
                                                                                    )
                                                                            ) || []

                                                                            return (
                                                                            <li
                                                                                key={
                                                                                index1
                                                                                }
                                                                                className={
                                                                                parseInt(
                                                                                    quspart.english_question_part_automark
                                                                                ) === 1
                                                                                    ? filteredStuAns.length >
                                                                                    0
                                                                                    ? "input_box e_input_box"
                                                                                    : "input_box e_input_box"
                                                                                    : " input_box e_input_box"
                                                                                }
                                                                            >
                                                                            { parseInt(InnerActivityData.english_question_category_id) === 2 ?
                                                                                <input
                                                                                id={
                                                                                index1 +
                                                                                Math.floor(
                                                                                    Math.random() *
                                                                                    5
                                                                                )
                                                                                }
                                                                                type="text"
                                                                                className={
                                                                                parseInt(
                                                                                    quspart.english_question_part_automark
                                                                                ) ===
                                                                                    1 &&
                                                                                quspart
                                                                                    .StudentAnsAttempts
                                                                                    .length >
                                                                                    0
                                                                                    ? filteredStuAns.length >
                                                                                    0
                                                                                    ? "answersuccess"
                                                                                    : "answererror "
                                                                                    : quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1 ? 
                                                                                    quspart.StudentAnsAttempts[0].attempt_status == 1 ?  "answersuccess"
                                                                                    : "answererror" 
                                                                                    : "answereditor"
                                                                                }
                                                                                value={
                                                                                filteredAllStuAns
                                                                                    .filter(
                                                                                    item =>
                                                                                        parseInt(
                                                                                        item.answer_id
                                                                                        ) ===
                                                                                        parseInt(
                                                                                        qusAns.english_answer_id
                                                                                        )
                                                                                    )
                                                                                    .reverse()
                                                                                    .map(
                                                                                    item =>
                                                                                        item.text
                                                                                    )
                                                                                    .find(
                                                                                    text =>
                                                                                        text !==
                                                                                        undefined
                                                                                    ) ||
                                                                                "" // Find the first non-undefined text value
                                                                                }
                                                                                disabled={
                                                                                true
                                                                                }
                                                                                //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                                onChange={e =>
                                                                                handletext(
                                                                                    e,
                                                                                    qusAns.english_answer_id,
                                                                                    qusAns.english_answer_part_id
                                                                                )
                                                                                }
                                                                                // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                            />
                                                                            :
                                                                                <textarea
                                                                                id={
                                                                                    index1 +
                                                                                    Math.floor(
                                                                                    Math.random() *
                                                                                        5
                                                                                    )
                                                                                }
                                                                                type="text"
                                                                                className={
                                                                                    parseInt(
                                                                                    quspart.english_question_part_automark
                                                                                    ) ===
                                                                                    1 &&
                                                                                    quspart
                                                                                    .StudentAnsAttempts
                                                                                    .length >
                                                                                    0
                                                                                    ? filteredStuAns.length >
                                                                                        0
                                                                                        ? "answersuccess"
                                                                                        : "answererror "
                                                                                    : quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1 ? 
                                                                                        quspart.StudentAnsAttempts[0].attempt_status == 1 ?  "answersuccess"
                                                                                        : "answererror" 
                                                                                    : "answereditor"
                                                                                }
                                                                                value={
                                                                                    filteredAllStuAns
                                                                                    .filter(
                                                                                        item =>
                                                                                        parseInt(
                                                                                            item.answer_id
                                                                                        ) ===
                                                                                        parseInt(
                                                                                            qusAns.english_answer_id
                                                                                        )
                                                                                    )
                                                                                    .reverse()
                                                                                    .map(
                                                                                        item =>
                                                                                        item.text
                                                                                    )
                                                                                    .find(
                                                                                        text =>
                                                                                        text !==
                                                                                        undefined
                                                                                    ) ||
                                                                                    "" // Find the first non-undefined text value
                                                                                }
                                                                                disabled={
                                                                                    true
                                                                                }
                                                                                //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                                onChange={e =>
                                                                                    handletext(
                                                                                    e,
                                                                                    qusAns.english_answer_id,
                                                                                    qusAns.english_answer_part_id
                                                                                    )
                                                                                }
                                                                                // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                                />
                                                                            }
                                                                            </li>
                                                                            )
                                                                        }
                                                                        }
                                                                    )}
                                                                </ul>
                                                                ) : quspart.english_question_part_answer_type ===
                                                                4 ? (
                                                                //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                                <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                    
                                                                    {quspart.english_question_answers &&
                                                                    rearrangeEvenOdd(
                                                                        quspart.english_question_answers
                                                                    ).map(
                                                                        (
                                                                        qusAns,
                                                                        index1
                                                                        ) => {
                                                                        const cleanText =
                                                                            qusAns.english_answer_text
                                                                            .replace(
                                                                                /&nbsp;/g,
                                                                                ""
                                                                            )
                                                                            .replace(
                                                                                /`/g,
                                                                                ""
                                                                            )
                                                                            .replace(
                                                                                /<[^>]*>/g,
                                                                                ""
                                                                            )
                                                                            .trim()

                                                                        const hasImage =
                                                                            /<img\s+[^>]*>/gi.test(
                                                                            qusAns.english_answer_text
                                                                            )

                                                                        if (
                                                                            !cleanText &&
                                                                            !hasImage
                                                                        ) {
                                                                            return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                        }

                                                                        serialNumber++

                                                                        let filteredStuAns =
                                                                            flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                                parseInt(
                                                                                stuAns.part_id
                                                                                ) ===
                                                                                parseInt(
                                                                                    qusAns.english_answer_part_id
                                                                                ) &&
                                                                                parseInt(
                                                                                stuAns.answer_id
                                                                                ) ===
                                                                                parseInt(
                                                                                    qusAns.english_answer_id
                                                                                )
                                                                            ) || []

                                                                        var status_color =
                                                                            "selector-general cursor-pointer"
                                                                        var border_color =
                                                                            "border-start-secondary"
                                                                        if (
                                                                            filteredStuAns.length >
                                                                            0 &&
                                                                            parseInt(
                                                                            quspart.english_question_part_automark
                                                                            ) === 1
                                                                        ) {
                                                                            if (
                                                                            parseInt(
                                                                                qusAns.english_answer_is_correct
                                                                            ) === 1
                                                                            ) {
                                                                            status_color =
                                                                                "selector-success"
                                                                            border_color =
                                                                                "border-start-success"
                                                                            } else {
                                                                            status_color =
                                                                                "selector-wrong "
                                                                            border_color =
                                                                                "border-start-danger"
                                                                            }
                                                                        }else if(quspart.StudentAnsAttempts.length > 0  &&
                                                                                quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1){
                                                                            if (
                                                                                quspart.StudentAnsAttempts[0].attempt_status == 1
                                                                            ) {
                                                                                status_color =
                                                                                "selector-success"
                                                                                border_color =
                                                                                "border-start-success"
                                                                            } else {
                                                                                status_color =
                                                                                "selector-wrong "
                                                                                border_color =
                                                                                "border-start-danger"
                                                                            }
                                                                        }

                                                                        
                                                                        //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                        return (
                                                                            <li
                                                                            className={
                                                                                status_color +
                                                                                " choose e_choose"
                                                                            }
                                                                            key={index1}
                                                                            >
                                                                            <div className="p-2 px-3 font-size-18">
                                                                                {
                                                                                serialNumber
                                                                                }
                                                                            </div>
                                                                            <div
                                                                                className={
                                                                                "p-2 dg-media " +
                                                                                {
                                                                                    border_color,
                                                                                }
                                                                                }
                                                                                dangerouslySetInnerHTML={{
                                                                                __html:
                                                                                    qusAns.english_answer_text
                                                                                    ? qusAns.english_answer_text
                                                                                    : null,
                                                                                }}
                                                                            ></div>
                                                                            </li>
                                                                        )
                                                                        }
                                                                    )}
                                                                </ul>
                                                                ) : (
                                                                <p className="text-center">
                                                                    No option
                                                                </p>
                                                                )}
                                                                {/* Anse category statement end */}
                                                            </div>
                                                            )
                                                        }
                                                        )}

                                                    {/* past question End */}

                                                    </div>
                                                </div>
                                                </li>
                                            </ul>

                                            </div>
                                        
                                        )
                                    } else if (
                                        InnerActivityData &&
                                        InnerActivityData.english_question_category_id &&
                                        (parseInt(
                                        InnerActivityData.english_question_category_id
                                        ) === 13 ||
                                        parseInt(
                                            InnerActivityData.english_question_category_id
                                        ) === 10)
                                    ) {
                                        return (
                                    
                                            <div className="hw-list mt-1 pb-50 not_scroll w-100">
                                            <ul className="list-unstyled mb-0 question_container">
                                                <li className="justify-content-between">
                                                <div className="d-flex align-items-start gap-4 justify-content-end">
                                                   
                                                    <div className="mb-0 d-flex align-items-center gap-2">
                                                    <h6 className="mb-0">
                                                        #
                                                        {InnerActivityData.english_question_id
                                                        ? InnerActivityData.english_question_id
                                                        : null}
                                                    </h6>
                                                
                                                    </div>
                                                </div>
                                                <div
                                                    className="mt-3"
                                                    dangerouslySetInnerHTML={{
                                                    __html:
                                                        InnerActivityData.english_question_instruction
                                                        ? InnerActivityData.english_question_instruction
                                                            .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                            )
                                                            .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                            )
                                                        : null,
                                                    }}
                                                ></div>
                                                {/* Choice */}
                                                {InnerActivityData &&
                                                InnerActivityData.english_question_choices &&
                                                InnerActivityData
                                                    .english_question_choices.length >
                                                    0 ? (
                                                    <div className="mt-4 my-2 border border-dark choice-options_wrapper">
                                                    {InnerActivityData.english_question_choices.map(
                                                        (qusChoice, Cindex) => (
                                                        <div
                                                            class="choice-options_child"
                                                            key={Cindex}
                                                        >
                                                            <div>
                                                            {qusChoice.choice_no}
                                                            </div>
                                                            <div>
                                                            {qusChoice.choice_text}
                                                            </div>
                                                        </div>
                                                        )
                                                    )}
                                                    </div>
                                                ) : null}

                                                <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                    __html:
                                                        InnerActivityData.english_question_text
                                                        ? InnerActivityData.english_question_text
                                                            .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                            )
                                                            .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                            )
                                                        : null,
                                                    }}
                                                ></div>
                                                {InnerActivityData &&
                                                InnerActivityData.part_heading &&
                                                InnerActivityData.part_heading !=
                                                    "" ? (
                                                    <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                        InnerActivityData.part_heading,
                                                    }}
                                                    ></div>
                                                ) : null}
                                                {/* File option */}
                                                <div className="mt-4 my-2">
                                                    {InnerActivityData &&
                                                    InnerActivityData.english_question_files &&
                                                    InnerActivityData
                                                    .english_question_files.length >
                                                    0
                                                    ? InnerActivityData.english_question_files.map(
                                                        (qusFile, imgindex) => (
                                                            <img
                                                            key={imgindex}
                                                            alt=""
                                                            style={{
                                                                height: "auto",
                                                                maxWidth: "100%",
                                                            }}
                                                            src={`https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/question_files/${qusFile.file_name}`}
                                                            />
                                                        )
                                                        )
                                                    : null}
                                                </div>

                                                {/* Past question */}
                                                {InnerActivityData.english_question_parts &&
                                                    InnerActivityData.english_question_parts.map(
                                                    (quspart, index) => {
                                                        if (
                                                        quspart.english_question_answers &&
                                                        quspart
                                                            .english_question_answers
                                                            .length > 0 &&
                                                        quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text &&
                                                        quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text != ""
                                                        ) {
                                                        const stuAnswersarray =
                                                            quspart.StudentAnsAttempts.map(
                                                            stuAns => {
                                                                try {
                                                                return JSON.parse(
                                                                    stuAns.student_answer
                                                                )
                                                                } catch (error) {
                                                                console.error(
                                                                    "Error parsing JSON:",
                                                                    error
                                                                )
                                                                return null // or handle the error in an appropriate way
                                                                }
                                                            }
                                                            ) || [] // Extracting session keys

                                                        // Assuming stuAnswersarray is a nested array
                                                        const flattenedStuAnswers =
                                                            [].concat(
                                                            ...stuAnswersarray
                                                            )
                                                        let serialNumber = 0
                                                        return (
                                                            <div
                                                            key={index}
                                                            className="d-flex justify-content-between align-items-center mt-3"
                                                            >
                                                            <div class="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="d-flex gap-2 flex-row ">
                                                                {/* <div className="mr-3">{index + 1}</div> */}
                                                                <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                    quspart.english_question_part_text
                                                                        ? quspart.english_question_part_text
                                                                            .replace(
                                                                            /\[\[(.+?)\]\]/g,
                                                                            function (
                                                                                match,
                                                                                p1
                                                                            ) {
                                                                                return p1.length >
                                                                                1
                                                                                ? `<span class="text-bg-yellow">${p1}</span>`
                                                                                : `<span class="text-bg-blue">${p1}</span>`
                                                                            }
                                                                            )
                                                                            .replace(
                                                                            /\{\{/g,
                                                                            "<u>"
                                                                            )
                                                                            .replace(
                                                                            /\}\}/g,
                                                                            "</u>"
                                                                            )
                                                                            .replace(
                                                                            /\[(\d+)Answer char=\d+\]/g,
                                                                            ""
                                                                            )
                                                                            .replace(
                                                                            /\[Answer char=\d+\]/g,
                                                                            ""
                                                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                            )
                                                                        : null,
                                                                }}
                                                                ></div>
                                                            </div>
                                                            {(quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 1) || (quspart.english_question_part_automark != 1 && ActivityData1.marked_for_manual_marking == 1) ? 
                                                                quspart.markedReport && quspart.markedReport > 0 ?
                                                                <div>
                                                                {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                                <span className="badge bg-warning font-size-12 mt-auto mb-2">Override</span>
                                                                </div>
                                                                :
                                                                null
                                                                : 
                                                                null
                                                            }
                                                            </div>
                                                            {/* Anse category statement Star */}
                                                            {quspart.english_question_part_answer_type ===
                                                                8 ||
                                                            quspart.english_question_part_answer_type ===
                                                                1 ||
                                                            quspart.english_question_part_answer_type ===
                                                                7 ? (
                                                                <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                {" "}
                                                                {quspart.english_question_answers &&
                                                                    quspart.english_question_answers.map(
                                                                    (
                                                                        qusAns,
                                                                        index1
                                                                    ) => {
                                                                        // Your logic for filtering student answers and determining status_color and border_color
                                                                        const stuAnswersarray =
                                                                        quspart.StudentAnsAttempts.map(
                                                                            stuAns => {
                                                                            try {
                                                                                return JSON.parse(
                                                                                stuAns.student_answer
                                                                                )
                                                                            } catch (error) {
                                                                                console.error(
                                                                                "Error parsing JSON:",
                                                                                error
                                                                                )
                                                                                return null // or handle the error in an appropriate way
                                                                            }
                                                                            }
                                                                        ) || [] // Extracting session keys
                                                                        //console.log(stuAnswersarray);
                                                                        // Assuming stuAnswersarray is a nested array
                                                                        const flattenedStuAnswers =
                                                                        [].concat(
                                                                            ...stuAnswersarray
                                                                        )
                                                                        let cleanedText =
                                                                        qusAns.english_answer_text
                                                                            .replace(
                                                                            /&nbsp;/g,
                                                                            ""
                                                                            )
                                                                            .replace(
                                                                            /`/g,
                                                                            ""
                                                                            )
                                                                            .replace(
                                                                            /<[^>]*>/g,
                                                                            ""
                                                                            ) || ""
                                                                        let resultTest =
                                                                        cleanedText
                                                                            .toLowerCase()
                                                                            .trim()
                                                                        let answers =
                                                                        resultTest.split(
                                                                            "|"
                                                                        ) || []
                                                                        let firstAnswer =
                                                                        answers[0]
                                                                            ? answers[0].trim()
                                                                            : "No_Data"
                                                                        let secondAnswer =
                                                                        answers[1]
                                                                            ? answers[1].trim()
                                                                            : "No_Data"
                                                                        let answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase()).filter(Boolean) || []; 
                                                                        if (
                                                                        qusAns.english_answer_is_correct ===
                                                                        1
                                                                        ) {
                                                                        let filteredStuAns =
                                                                            flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                                parseInt(
                                                                                stuAns.part_id
                                                                                ) ===
                                                                                parseInt(
                                                                                    qusAns.english_answer_part_id
                                                                                ) &&
                                                                                (stuAns.text
                                                                                .toLowerCase()
                                                                                .trim() ==
                                                                                resultTest ||
                                                                                stuAns.text
                                                                                    .toLowerCase()
                                                                                    .trim() ==
                                                                                    firstAnswer ||
                                                                                stuAns.text
                                                                                    .toLowerCase()
                                                                                    .trim() ==
                                                                                    secondAnswer ||
                                                                                answersArray.some(answer => answer == stuAns.text
                                                                                    .toLowerCase()
                                                                                    .trim())) &&
                                                                                parseInt(
                                                                                stuAns.answer_id
                                                                                ) ===
                                                                                parseInt(
                                                                                    qusAns.english_answer_id
                                                                                )
                                                                            ) || []

                                                                        let filteredAllStuAns =
                                                                            flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                                parseInt(
                                                                                stuAns.part_id
                                                                                ) ===
                                                                                parseInt(
                                                                                    qusAns.english_answer_part_id
                                                                                ) &&
                                                                                parseInt(
                                                                                stuAns.answer_id
                                                                                ) ===
                                                                                parseInt(
                                                                                    qusAns.english_answer_id
                                                                                )
                                                                            ) || []

                                                                        return (
                                                                            <li
                                                                            key={
                                                                                index1
                                                                            }
                                                                            className={
                                                                                parseInt(
                                                                                quspart.english_question_part_automark
                                                                                ) ===
                                                                                1
                                                                                ? filteredStuAns.length >
                                                                                    0
                                                                                    ? "input_box small_input_box"
                                                                                    : "input_box small_input_box"
                                                                                : " input_box small_input_box"
                                                                            }
                                                                            >
                                                                            <input
                                                                                id={
                                                                                index1 +
                                                                                Math.floor(
                                                                                    Math.random() *
                                                                                    5
                                                                                )
                                                                                }
                                                                                type="text"
                                                                                className={
                                                                                parseInt(
                                                                                    quspart.english_question_part_automark
                                                                                ) ===
                                                                                    1 &&
                                                                                quspart
                                                                                    .StudentAnsAttempts
                                                                                    .length >
                                                                                    0
                                                                                    ? filteredStuAns.length >
                                                                                    0
                                                                                    ? "answersuccess"
                                                                                    : "answererror "
                                                                                    : quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1 ? 
                                                                                    quspart.StudentAnsAttempts[0].attempt_status == 1 ?  "answersuccess"
                                                                                    : "answererror" 
                                                                                    : "answereditor"
                                                                                }
                                                                                value={
                                                                                filteredAllStuAns
                                                                                    .filter(
                                                                                    item =>
                                                                                        parseInt(
                                                                                        item.answer_id
                                                                                        ) ===
                                                                                        parseInt(
                                                                                        qusAns.english_answer_id
                                                                                        )
                                                                                    )
                                                                                    .reverse()
                                                                                    .map(
                                                                                    item =>
                                                                                        item.text
                                                                                    )
                                                                                    .find(
                                                                                    text =>
                                                                                        text !==
                                                                                        undefined
                                                                                    ) ||
                                                                                "" // Find the first non-undefined text value
                                                                                }
                                                                                disabled={
                                                                                true
                                                                                }
                                                                                //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                                onChange={e =>
                                                                                handletext(
                                                                                    e,
                                                                                    qusAns.english_answer_id,
                                                                                    qusAns.english_answer_part_id
                                                                                )
                                                                                }
                                                                                // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                            />
                                                                            </li>
                                                                        )
                                                                        }
                                                                    }
                                                                    )}
                                                                </ul>
                                                            ) : quspart.english_question_part_answer_type ===
                                                                4 ? (
                                                                //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                                <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                
                                                                {quspart.english_question_answers &&
                                                                    rearrangeEvenOdd(
                                                                    quspart.english_question_answers
                                                                    ).map(
                                                                    (
                                                                        qusAns,
                                                                        index1
                                                                    ) => {
                                                                        const cleanText =
                                                                        qusAns.english_answer_text
                                                                            .replace(
                                                                            /&nbsp;/g,
                                                                            ""
                                                                            )
                                                                            .replace(
                                                                            /`/g,
                                                                            ""
                                                                            )
                                                                            .replace(
                                                                            /<[^>]*>/g,
                                                                            ""
                                                                            )
                                                                            .trim()

                                                                        const hasImage =
                                                                        /<img\s+[^>]*>/gi.test(
                                                                            qusAns.english_answer_text
                                                                        )

                                                                        if (
                                                                        !cleanText &&
                                                                        !hasImage
                                                                        ) {
                                                                        return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                        }

                                                                        serialNumber++

                                                                        let filteredStuAns =
                                                                        flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                            parseInt(
                                                                                stuAns.part_id
                                                                            ) ===
                                                                                parseInt(
                                                                                qusAns.english_answer_part_id
                                                                                ) &&
                                                                            parseInt(
                                                                                stuAns.answer_id
                                                                            ) ===
                                                                                parseInt(
                                                                                qusAns.english_answer_id
                                                                                )
                                                                        ) || []

                                                                        var status_color =
                                                                        "selector-general cursor-pointer"
                                                                        var border_color =
                                                                        "border-start-secondary"
                                                                        if (
                                                                        filteredStuAns.length >
                                                                            0 &&
                                                                        parseInt(
                                                                            quspart.english_question_part_automark
                                                                        ) === 1
                                                                        ) {
                                                                        if (
                                                                            parseInt(
                                                                            qusAns.english_answer_is_correct
                                                                            ) === 1
                                                                        ) {
                                                                            status_color =
                                                                            "selector-success"
                                                                            border_color =
                                                                            "border-start-success"
                                                                        } else {
                                                                            status_color =
                                                                            "selector-wrong "
                                                                            border_color =
                                                                            "border-start-danger"
                                                                        }
                                                                        }else if(quspart.StudentAnsAttempts.length > 0 &&
                                                                        quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1){
                                                                        if (
                                                                            quspart.StudentAnsAttempts[0].attempt_status == 1
                                                                        ) {
                                                                            status_color =
                                                                            "selector-success"
                                                                            border_color =
                                                                            "border-start-success"
                                                                        } else {
                                                                            status_color =
                                                                            "selector-wrong "
                                                                            border_color =
                                                                            "border-start-danger"
                                                                        }
                                                                    }
                                                                        //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                        return (
                                                                        <li
                                                                            className={
                                                                            status_color +
                                                                            " choose e_choose"
                                                                            }
                                                                            key={
                                                                            index1
                                                                            }
                                                                        >
                                                                            <div className="p-2 px-3 font-size-18">
                                                                            {
                                                                                serialNumber
                                                                            }
                                                                            </div>
                                                                            <div
                                                                            className={
                                                                                "p-2 dg-media " +
                                                                                {
                                                                                border_color,
                                                                                }
                                                                            }
                                                                            dangerouslySetInnerHTML={{
                                                                                __html:
                                                                                qusAns.english_answer_text
                                                                                    ? qusAns.english_answer_text
                                                                                    : null,
                                                                            }}
                                                                            ></div>
                                                                        </li>
                                                                        )
                                                                    }
                                                                    )}
                                                                </ul>
                                                            ) : (
                                                                <p className="text-center">
                                                                No option
                                                                </p>
                                                            )}
                                                            {/* Anse category statement end */}
                                                            </div>
                                                        )
                                                        } else {
                                                        return quspart.english_question_part_text ? (
                                                            <div
                                                            key={index}
                                                            className="mt-3"
                                                            >
                                                            <div className="d-flex gap-2 flex-row ">
                                                                {/* <div className="mr-3">{index + 1}</div> */}
                                                                <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                    quspart.english_question_part_text
                                                                        ? quspart.english_question_part_text
                                                                            .replace(
                                                                            /\[\[(.+?)\]\]/g,
                                                                            function (
                                                                                match,
                                                                                p1
                                                                            ) {
                                                                                return p1.length >
                                                                                1
                                                                                ? `<span class="text-bg-yellow">${p1}</span>`
                                                                                : `<span class="text-bg-blue">${p1}</span>`
                                                                            }
                                                                            )
                                                                            .replace(
                                                                            /\{\{/g,
                                                                            "<u>"
                                                                            )
                                                                            .replace(
                                                                            /\}\}/g,
                                                                            "</u>"
                                                                            )
                                                                            .replace(
                                                                            /\[(\d+)Answer char=\d+\]/g,
                                                                            ""
                                                                            )
                                                                            .replace(
                                                                            /\[Answer char=\d+\]/g,
                                                                            ""
                                                                            )
                                                                        : null,
                                                                }}
                                                                ></div>
                                                            </div>
                                                            </div>
                                                        ) : null
                                                        }
                                                    }
                                                    )}

                                                {/* past question End */}

                                                </li>
                                            </ul>

                                            </div>
                                        
                                        )
                                    } else {
                                        return (
                                        <p className="text-center">No question</p>
                                        )
                                    }
                                    }
                                }
                                )
                            } else if (
                                ActivityData1 &&
                                ActivityData1.fk_sub_id &&
                                parseInt(ActivityData1.fk_sub_id) === 2
                            ) {
                                return ActivityData1.question.map(
                                (InnerActivityData, index) => {
                                    if (index === 0) {
                                    if (
                                        InnerActivityData &&
                                        InnerActivityData.question_parts &&
                                        InnerActivityData.question_parts.length > 0
                                    ) {
                                        return (
                                        
                                            <div className="hw-list mt-1 pb-50 not_scrol w-100">
                                            <ul className="list-unstyled mb-0 question_container">
                                                <li className="justify-content-between">
                                                <div className="d-flex align-items-start gap-4 justify-content-end">
                                                    
                                                    <div className="mb-0 d-flex align-items-center gap-2">
                                                    <h6 className="mb-0">
                                                        #
                                                        {InnerActivityData.question_id
                                                        ? InnerActivityData.question_id
                                                        : null}
                                                    </h6>
                                                
                                                    
                                                    
                                                    </div>
                                                </div>

                                                <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                    __html:
                                                        InnerActivityData.question_text
                                                        ? InnerActivityData.question_text
                                                            .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                            )
                                                            .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                            )
                                                        : null,
                                                    }}
                                                ></div>

                                                {/* Past question */}
                                                {InnerActivityData.question_parts &&
                                                    InnerActivityData.question_parts.map(
                                                    (quspart, index) => {
                                                        const stuAnswersarray =
                                                        quspart.StudentAnsAttempts.map(
                                                            stuAns => {
                                                            try {
                                                                return JSON.parse(
                                                                stuAns.student_answer
                                                                )
                                                            } catch (error) {
                                                                console.error(
                                                                "Error parsing JSON:",
                                                                error
                                                                )
                                                                return null // or handle the error in an appropriate way
                                                            }
                                                            }
                                                        ) || [] // Extracting session keys

                                                        // Assuming stuAnswersarray is a nested array
                                                        const flattenedStuAnswers =
                                                        [].concat(
                                                            ...stuAnswersarray
                                                        )
                                                        let serialNumber = 0
                                                        return (
                                                        <div key={index}>
                                                            <div class="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="d-flex gap-2 flex-row ">
                                                            <div className="mr-3">
                                                                {index + 1}
                                                                {")"}
                                                            </div>
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                __html:
                                                                    quspart.part_text
                                                                    ? quspart.part_text
                                                                        .replace(
                                                                            /\[(\d+)Answer char=\d+\]/g,
                                                                            ""
                                                                        )
                                                                        .replace(
                                                                            /\[Answer char=\d+\]/g,
                                                                            ""
                                                                        ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                            )
                                                                    : null,
                                                                }}
                                                            ></div>
                                                            </div>
                                                            {quspart.StudentAnsAttempts.length > 0 ? 
                                                            quspart.markedReport && quspart.markedReport > 0 ?
                                                                <div>
                                                                {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                                <span className="badge bg-warning font-size-12 mt-auto mb-2">Override</span>
                                                                </div>
                                                            :
                                                            null
                                                            : 
                                                            null
                                                            }
                                                        </div>
                                                            {/* Anse category statement Star */}
                                                            {quspart.part_answer_type ===
                                                            2 ? (
                                                            <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                {quspart.question_answers &&
                                                                quspart.question_answers.map(
                                                                    (
                                                                    qusAns,
                                                                    index1
                                                                    ) => {
                                                                    if (
                                                                        quspart
                                                                        .StudentAnsAttempts
                                                                        .length > 0
                                                                    ) {
                                                                        return quspart.StudentAnsAttempts.map(
                                                                        (
                                                                            qusStuAns,
                                                                            stuAnsindex
                                                                        ) => {
                                                                            // Your logic for filtering student answers and determining status_color and border_color
                                                                            const stuAnswersarray =
                                                                            quspart.StudentAnsAttempts.filter(
                                                                                stuAns =>
                                                                                stuAns.atempt_count ===
                                                                                stuAnsindex +
                                                                                    1
                                                                            ).map(
                                                                                stuAns => {
                                                                                try {
                                                                                    return JSON.parse(
                                                                                    stuAns.student_answer
                                                                                    )
                                                                                } catch (error) {
                                                                                    console.error(
                                                                                    "Error parsing JSON:",
                                                                                    error
                                                                                    )
                                                                                    return null // or handle the error in an appropriate way
                                                                                }
                                                                                }
                                                                            ) || []

                                                                            //console.log(stuAnswersarray);
                                                                            // Assuming stuAnswersarray is a nested array
                                                                            const flattenedStuAnswers =
                                                                            [].concat(
                                                                                ...stuAnswersarray
                                                                            )
                                                                            //  let cleanedText = qusAns.answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '') || '';
                                                                            //  let resultTest = cleanedText.toLowerCase().trim();
                                                                            //  let answers = resultTest.split('|') || [];
                                                                            //  let firstAnswer = answers[0] ? answers[0].trim() : "";
                                                                            //  let secondAnswer = answers[1] ? answers[1].trim() : "";

                                                                            if (
                                                                            qusAns.answer_is_correct ===
                                                                            1
                                                                            ) {
                                                                            let filteredStuAns =
                                                                                flattenedStuAnswers.filter(
                                                                                stuAns =>
                                                                                    parseInt(
                                                                                    stuAns.part_id
                                                                                    ) ===
                                                                                    parseInt(
                                                                                        qusAns.answer_part_id
                                                                                    ) &&
                                                                                    parseInt(
                                                                                    qusStuAns.attempt_status
                                                                                    ) ===
                                                                                    1 &&
                                                                                    parseInt(
                                                                                    stuAns.answer_id
                                                                                    ) ===
                                                                                    parseInt(
                                                                                        qusAns.answer_id
                                                                                    )
                                                                                ) ||
                                                                                []

                                                                            let filteredAllStuAns =
                                                                                flattenedStuAnswers.filter(
                                                                                stuAns =>
                                                                                    parseInt(
                                                                                    stuAns.part_id
                                                                                    ) ===
                                                                                    parseInt(
                                                                                        qusAns.answer_part_id
                                                                                    ) &&
                                                                                    parseInt(
                                                                                    stuAns.answer_id
                                                                                    ) ===
                                                                                    parseInt(
                                                                                        qusAns.answer_id
                                                                                    )
                                                                                ) ||
                                                                                []

                                                                            return (
                                                                                <li
                                                                                key={
                                                                                    index1
                                                                                }
                                                                                className={
                                                                                    filteredStuAns.length >
                                                                                    0
                                                                                    ? " input_box m_input_box"
                                                                                    : "input_box m_input_box"
                                                                                }
                                                                                >
                                                                                <input
                                                                                    id={
                                                                                    index1 +
                                                                                    Math.floor(
                                                                                        Math.random() *
                                                                                        5
                                                                                    )
                                                                                    }
                                                                                    type="text"
                                                                                    className={
                                                                                    parseInt(
                                                                                        qusStuAns.attempt_status
                                                                                    ) ===
                                                                                    1
                                                                                        ? "answersuccess"
                                                                                        : "answererror"
                                                                                    }
                                                                                    value={
                                                                                    filteredAllStuAns
                                                                                        .filter(
                                                                                        item =>
                                                                                            parseInt(
                                                                                            item.answer_id
                                                                                            ) ===
                                                                                            parseInt(
                                                                                            qusAns.answer_id
                                                                                            )
                                                                                        )
                                                                                        .map(
                                                                                        item =>
                                                                                            item.text
                                                                                        )
                                                                                        .find(
                                                                                        text =>
                                                                                            text !==
                                                                                            undefined
                                                                                        ) ||
                                                                                    "" // Find the first non-undefined text value
                                                                                    }
                                                                                    disabled={
                                                                                    true
                                                                                    }
                                                                                    //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                                    onChange={e =>
                                                                                    handletext(
                                                                                        e,
                                                                                        qusAns.answer_id,
                                                                                        qusAns.answer_part_id
                                                                                    )
                                                                                    }
                                                                                    // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                                />
                                                                                </li>
                                                                            )
                                                                            }
                                                                        }
                                                                        )
                                                                    } else {
                                                                        return (
                                                                        <li
                                                                            key={
                                                                            index1
                                                                            }
                                                                            className={
                                                                            "input_box m_input_box"
                                                                            }
                                                                        >
                                                                            <input
                                                                            id={
                                                                                index1 +
                                                                                Math.floor(
                                                                                Math.random() *
                                                                                    5
                                                                                )
                                                                            }
                                                                            type="text"
                                                                            className={
                                                                                "answereditor"
                                                                            }
                                                                            value={
                                                                                "" // Find the first non-undefined text value
                                                                            }
                                                                            disabled={
                                                                                true
                                                                            }
                                                                            //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                            //onChange={(e) => handletext(e, qusAns.answer_id, qusAns.answer_part_id)}
                                                                            // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                            />
                                                                        </li>
                                                                        )
                                                                    }
                                                                    }
                                                                )}
                                                            </ul>
                                                            ) : quspart.part_answer_type ===
                                                            4 ? (
                                                            //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                            <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                {quspart.question_answers &&
                                                                rearrangeEvenOdd(
                                                                    quspart.question_answers
                                                                ).map(
                                                                    (
                                                                    qusAns,
                                                                    index1
                                                                    ) => {
                                                                    const cleanText =
                                                                        qusAns.answer_text
                                                                        .replace(
                                                                            /&nbsp;/g,
                                                                            ""
                                                                        )
                                                                        .replace(
                                                                            /`/g,
                                                                            ""
                                                                        )
                                                                        .replace(
                                                                            /<[^>]*>/g,
                                                                            ""
                                                                        )
                                                                        .trim()

                                                                    const hasImage =
                                                                        /<img\s+[^>]*>/gi.test(
                                                                        qusAns.answer_text
                                                                        )

                                                                    if (
                                                                        !cleanText &&
                                                                        !hasImage
                                                                    ) {
                                                                        return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                    }

                                                                    serialNumber++
                                                                    let filteredStuAns =
                                                                        flattenedStuAnswers.filter(
                                                                        stuAns =>
                                                                            parseInt(
                                                                            stuAns.part_id
                                                                            ) ===
                                                                            parseInt(
                                                                                qusAns.answer_part_id
                                                                            ) &&
                                                                            parseInt(
                                                                            stuAns.answer_id
                                                                            ) ===
                                                                            parseInt(
                                                                                qusAns.answer_id
                                                                            )
                                                                        ) || []

                                                                    var status_color =
                                                                        "selector-general cursor-pointer"
                                                                    var border_color =
                                                                        "border-start-secondary"
                                                                    if (
                                                                        filteredStuAns.length >
                                                                        0
                                                                    ) {
                                                                        if (
                                                                        parseInt(
                                                                            qusAns.answer_is_correct
                                                                        ) === 1
                                                                        ) {
                                                                        status_color =
                                                                            "selector-success"
                                                                        border_color =
                                                                            "border-start-success"
                                                                        } else {
                                                                        status_color =
                                                                            "selector-wrong "
                                                                        border_color =
                                                                            "border-start-danger"
                                                                        }
                                                                    }
                                                                    //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                    return (
                                                                        <li
                                                                        className={
                                                                            status_color +
                                                                            " choose m_choose"
                                                                        }
                                                                        key={index1}
                                                                        >
                                                                        <div className="p-2 px-3 font-size-18">
                                                                            {
                                                                            serialNumber
                                                                            }
                                                                        </div>
                                                                        <div
                                                                            className={
                                                                            "p-2 dg-media " +
                                                                            {
                                                                                border_color,
                                                                            }
                                                                            }
                                                                            dangerouslySetInnerHTML={{
                                                                            __html:
                                                                                qusAns.answer_text
                                                                                ? qusAns.answer_text
                                                                                : null,
                                                                            }}
                                                                        ></div>
                                                                        </li>
                                                                    )
                                                                    }
                                                                )}
                                                            </ul>
                                                            ) : (
                                                            <p className="text-center">
                                                                No option
                                                            </p>
                                                            )}
                                                            {/* Anse category statement end */}
                                                        </div>
                                                        )
                                                    }
                                                    )}

                                                </li>
                                            </ul>
                                            
                                            
                                            </div>
                                        )
                                    } else {
                                        return (
                                        <p className="text-center">No question</p>
                                        )
                                    }
                                    }
                                }
                                )
                            }
                            }
                        )
                        : null}
            </div>
        </div>
    )
    : type === 'SummativePopup' ?
    (
        <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '795px',       // use viewport width
                height: 'auto',
                opacity: 0,
                pointerEvents: 'none',
                zIndex: -1,              // keep it below everything
            }}>
            <div ref={contentRef} className="pdf-content" 
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    fontSize: '16px',
                    width: '100%',
                    maxWidth: '100%',
                    lineHeight: '1.4',
                    color: 'black' // Bark black or very dark black
                }}>
                <div className="d-flex align-items-center justify-content-between w-100 text-black">
                    <h6 className="mb-0 font-size-20 w-60 fw-500">
                    {name ? name : 'Summative'}
                    </h6>
                    <div className="d-flex align-items-center gap-4">
                      <div className="font-size-16">
                        <img width={24} className="" src={awicon} alt="" /> 0 /{" "}
                        {ActivityData &&
                        ActivityData.length > 0 ? CountTotalCoinsForActivity(ActivityData) : 0}{" "}
                        coins earned
                      </div>
                    </div>
                </div>
                {ActivityData &&
                ActivityData.length > 0 && 
                ActivityData.map(
                    (activity, popactivityindex) => {
                    
                        {
                            if(activity.subjectId == '1'){

                                return(
                                        <div className="hw-list mt-1 pb-50 w-100">
                                            <div>
                                                <div className={"QuestionBody jss13 mb-3 w-100"}>
                                                    <div className="d-flex align-items-start gap-4 justify-content-end">
                                                        <div className="mb-0 d-flex align-items-center gap-2">
                                                            <h6 className="mb-0">
                                                                #
                                                                {activity.questionId
                                                                ? activity.questionId
                                                                : null}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div
                                                        className="mt-3 w-100"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                            activity.question_details &&
                                                            activity.question_details
                                                                .english_question_instruction
                                                                ? activity.question_details &&
                                                                activity.question_details.english_question_instruction
                                                                    .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                    .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                : null,
                                                        }}
                                                        ></div>

                                                        {activity.question_details &&
                                                        activity.question_details
                                                        .english_question_choices &&
                                                        activity.question_details
                                                        .english_question_choices.length >
                                                        0 ? (
                                                        <div className="mt-3 my-2 border border-dark choice-options_wrapper">
                                                            {activity.question_details.english_question_choices.map(
                                                            (qusChoice, Cindex) => (
                                                                <div
                                                                class="choice-options_child"
                                                                key={Cindex}
                                                                >
                                                                <div>
                                                                    {qusChoice.choice_no}
                                                                </div>
                                                                <div>
                                                                    {qusChoice.choice_text}
                                                                </div>
                                                                </div>
                                                            )
                                                            )}
                                                        </div>
                                                        ) : null}

                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id ===
                                                            1 &&
                                                        (activity.question_details
                                                            .english_question_text ? (
                                                            <div
                                                            className="mt-3"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                activity.question_details.english_question_text
                                                                    .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                    .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                    ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                        '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                    ),
                                                            }}
                                                            />
                                                        ) : null)}

                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id ===
                                                            2 &&
                                                        (activity.question_details
                                                            .english_question_text ? (
                                                            <div
                                                            className="mt-3"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                activity.question_details.english_question_text
                                                                    .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                    .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                    ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                        '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                    ),
                                                            }}
                                                            />
                                                        ) : null)}

                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id ===
                                                            8 &&
                                                        (activity.question_details
                                                            .english_question_text ? (
                                                            <div
                                                            className="mt-4"
                                                            dangerouslySetInnerHTML={{
                                                                __html: activity
                                                                .question_details
                                                                .english_question_text
                                                                ? activity.question_details.english_question_text
                                                                    .replace(
                                                                        /\[(\d+)Answer char=\d+\]/g,
                                                                        ""
                                                                    )
                                                                    .replace(
                                                                        /\[Answer char=\d+\]/g,
                                                                        ""
                                                                    )
                                                                    .replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                        '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                    )
                                                                    .replace(/&nbsp;/g, "")
                                                                    .split("</p>")
                                                                    .map(
                                                                        (paragraph, index) =>
                                                                        paragraph
                                                                            ? `<div class="d-flex mt-2"><p class="me-2">${
                                                                                index + 1
                                                                            } ${paragraph}</p></div>`
                                                                            : ""
                                                                    )
                                                                    .filter(Boolean)
                                                                    .join("")
                                                                : null,
                                                            }}
                                                            />
                                                        ) : //  <div className="mt-3" dangerouslySetInnerHTML={{ __html: activity.english_question.english_question_text.replace(/\[(\d+)Answer char=\d+\]/g, '').replace(/\[Answer char=\d+\]/g, '') }} />
                                                        null)}

                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        (parseInt(
                                                            activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id
                                                        ) === 10 ||
                                                            parseInt(
                                                            activity.question_details
                                                                .english_question_new_category
                                                                .english_question_category_id
                                                            ) === 13) &&
                                                        (activity.question_details
                                                            .english_question_text ? (
                                                            <div
                                                            className="mt-3"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                activity.question_details.english_question_text
                                                                    .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                    .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                    ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                        '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                    ),
                                                            }}
                                                            />
                                                        ) : null)}

                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        (parseInt(
                                                            activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id
                                                        ) === 10 ||
                                                            parseInt(
                                                            activity.question_details
                                                                .english_question_new_category
                                                                .english_question_category_id
                                                            ) === 13) &&
                                                        (activity.question_details
                                                            .part_heading ? (
                                                            <div
                                                            className="mt-3"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                activity.question_details.part_heading
                                                                    .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                    )
                                                                    .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                    ),
                                                            }}
                                                            />
                                                        ) : null)}
                                                    </div>
                                                </div>
                                                <div>
                                                {activity &&
                                                activity.question_details &&
                                                activity.question_details
                                                    .question_parts &&
                                                activity.question_details
                                                    .question_parts &&
                                                activity.question_details.question_parts.map(
                                                    (
                                                    activityQuestion,
                                                    indexactivityQuestion
                                                    ) => (
                                                    <>

                                                    

                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id ==
                                                            1 && (
                                                            <ul className="dg-selector list-unstyled mb-0 pt-4 w-100">
                                                            
                                                            {activityQuestion &&
                                                                activityQuestion.question_answers &&
                                                                (() => {
                                                                let serialNumber = 0 // Initialize a separate counter for serial numbers
                                                                return rearrangeEvenOdd(
                                                                    activityQuestion.question_answers
                                                                ).map(
                                                                    (
                                                                    activityQuestionAns,
                                                                    indexQuestionAns
                                                                    ) => {
                                                                    if (
                                                                        activityQuestionAns &&
                                                                        activityQuestionAns.english_answer_text
                                                                    ) {

                                                                        const cleanText = activityQuestionAns.english_answer_text
                                                                        .replace(/&nbsp;/g, '')
                                                                        .replace(/`/g, '')
                                                                        .replace(/<[^>]*>/g, '')
                                                                        .trim();

                                                                        const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.english_answer_text);
                            
                                                                        if (!cleanText && !hasImage) {
                                                                            return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                        }
                                                                        serialNumber++ // Increment serial number only when there's valid text

                                                                        return (
                                                                        <li
                                                                            key={
                                                                            indexQuestionAns
                                                                            }
                                                                            className={"selector-display1"}>
                                                                            <div className="p-2 px-3 font-size-18">
                                                                            {
                                                                                serialNumber
                                                                            }
                                                                            </div>
                                                                            <div className="p-2 px-3 dg-media border-start-display">
                                                                            <div
                                                                                dangerouslySetInnerHTML={{
                                                                                __html:
                                                                                    activityQuestionAns.english_answer_text,
                                                                                }}
                                                                            />
                                                                            </div>
                                                                        </li>
                                                                        )
                                                                    }

                                                                    return null // Skip rendering if there's no answer text
                                                                    }
                                                                )
                                                                })()}
                                                            </ul>
                                                        )}

                                                        
                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id ==
                                                            2 && (
                                                            <>
                                                            <div className="mr-3">
                                                                {indexactivityQuestion +
                                                                1}
                                                                {")"}
                                                            </div>
                                                            <ul className="dg-selector list-unstyled mb-0 pt-2">
                                                                
                                                                {activityQuestion &&
                                                                activityQuestion.question_answers &&
                                                                (() => {
                                                                    let serialNumber = 0 // Separate counter for serial number
                                                                    const answers = activityQuestion.english_question_part_answer_type === 4
                                                                                    ? rearrangeEvenOdd(activityQuestion.question_answers)
                                                                                    : activityQuestion.question_answers || [];
                                                                                    
                                                                    return answers.map(
                                                                    (
                                                                        activityQuestionAns2,
                                                                        indexQuestionAns2
                                                                    ) => {
                                                                        if (
                                                                        activityQuestionAns2 &&
                                                                        activityQuestionAns2.english_answer_text
                                                                        ) {

                                                                        const cleanText = activityQuestionAns2.english_answer_text
                                                                        .replace(/&nbsp;/g, '')
                                                                        .replace(/`/g, '')
                                                                        .replace(/<[^>]*>/g, '')
                                                                        .trim();

                                                                            const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns2.english_answer_text);
                            
                                                                            if (!cleanText && !hasImage) {
                                                                                return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                            }
                                                                        serialNumber++ // Increment serial number only if there's a valid answer text

                                                                        return (
                                                                            <li
                                                                            key={
                                                                                indexQuestionAns2
                                                                            }
                                                                            className={"selector-display1"}
                                                                            >
                                                                            {activityQuestion.english_question_part_answer_type === 4 ? 
                                                                            <>
                                                                            <div className="p-2 px-3 font-size-18">
                                                                                {
                                                                                serialNumber
                                                                                }
                                                                            </div>
                                                                             <div className="p-2 px-3 dg-media border-start-display">
                                                                                <div
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html:
                                                                                    activityQuestionAns2.english_answer_text,
                                                                                }}
                                                                                />
                                                                            </div></> : 
                                                                            <div className="p-2 px-3 dg-media border-start-display custom-height">
                                                                                {/* {Input box} */}
                                                                            </div>}
                                                                            </li>
                                                                        )
                                                                        }

                                                                        return null // Skip rendering if answer text is null
                                                                    }
                                                                    )
                                                                })()}
                                                            </ul>
                                                            </>
                                                        )}

                                                        
                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id ==
                                                            8 && (
                                                            <>
                                                            <div className="p-2 px-3 font-size-18">
                                                                {activityQuestion &&
                                                                activityQuestion.english_question_part_text ? (
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                    __html: `${
                                                                        indexactivityQuestion +
                                                                        1
                                                                    }) ${activityQuestion.english_question_part_text
                                                                        .replace(
                                                                        /\[(\d+)Answer char=\d+\]/g,
                                                                        ""
                                                                        )
                                                                        .replace(
                                                                        /\[Answer char=\d+\]/g,
                                                                        ""
                                                                        ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                            '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                        )}`,
                                                                    }}
                                                                />
                                                                ) : (
                                                                ""
                                                                )}
                                                            </div>

                                                            <ul className="dg-selector list-unstyled mb-0 pt-4">
                                                            
                                                                {activityQuestion &&
                                                                activityQuestion.question_answers &&
                                                                (() => {
                                                                    let serialNumber = 0 // Separate counter for serial number
                                                                    const answers = activityQuestion.english_question_part_answer_type === 4
                                                                    ? rearrangeEvenOdd(activityQuestion.question_answers)
                                                                    : activityQuestion.question_answers || [];
                                                                    // return rearrangeEvenOdd(
                                                                    //   activityQuestion.question_answers
                                                                    // ).map(
                                                                    return answers.map((
                                                                        activityQuestionAns,
                                                                        indexQuestionAns
                                                                    ) => {
                                                                        if (
                                                                        activityQuestionAns &&
                                                                        activityQuestionAns.english_answer_text
                                                                        ) {
                                                                        const cleanText = activityQuestionAns.english_answer_text
                                                                        .replace(/&nbsp;/g, '')
                                                                        .replace(/`/g, '')
                                                                        .replace(/<[^>]*>/g, '')
                                                                        .trim();

                                                                            const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.english_answer_text);
                            
                                                                            if (!cleanText && !hasImage) {
                                                                                return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                            }
                                                                        serialNumber++ // Increment serial number only if answer text is valid

                                                                        return (
                                                                            <li
                                                                            key={
                                                                                indexQuestionAns
                                                                            }
                                                                            className={"selector-display1"}
                                                                            >
                                                                            {activityQuestion.english_question_part_answer_type === 4 ?
                                                                            <>
                                                                            <div className="p-2 px-3 font-size-18">
                                                                                {
                                                                                serialNumber
                                                                                }
                                                                            </div>
                                                                            <div className="p-2 px-3 dg-media border-start-display">
                                                                                <div
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html:
                                                                                    activityQuestionAns.english_answer_text,
                                                                                }}
                                                                                />
                                                                            </div>
                                                                            </>
                                                                            : 
                                                                            <div className="p-2 px-3 dg-media border-start-display custom-height">
                                                                                {/* {Input box} */}
                                                                            </div>}
                                                                            
                                                                            </li>
                                                                        )
                                                                        }

                                                                        return null // Skip if answer text is null
                                                                    }
                                                                    )
                                                                })()}
                                                            </ul>
                                                            </>
                                                        )}
                                                        
                                                        {activity.question_details &&
                                                        activity.question_details
                                                            .english_question_new_category &&
                                                        (parseInt(
                                                            activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id
                                                        ) === 13 ||
                                                            parseInt(
                                                            activity.question_details
                                                                .english_question_new_category
                                                                .english_question_category_id
                                                            ) === 10) && (
                                                            <>
                                                            {/* <ul className="dg-selector list-unstyled mb-0 pt-4"> */}
                                                            <div class="q_a-preview pt-3 d-flex justify-content-between align-items-center">
                                                                {activityQuestion &&
                                                                activityQuestion.english_question_part_text ? (
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        activityQuestion.english_question_part_text
                                                                        .replace(
                                                                            /\[(\d+)Answer char=\d+\]/g,
                                                                            ""
                                                                        )
                                                                        .replace(
                                                                            /\[Answer char=\d+\]/g,
                                                                            ""
                                                                        )
                                                                        .replace(
                                                                            /\[\[(.+?)\]\]/g,
                                                                            function (
                                                                            match,
                                                                            p1
                                                                            ) {
                                                                            return p1.length >
                                                                                1
                                                                                ? `<span class="text-bg-yellow">${p1}</span>`
                                                                                : `<span class="text-bg-blue">${p1}</span>`
                                                                            }
                                                                        )
                                                                        .replace(
                                                                            /\{\{/g,
                                                                            "<u>"
                                                                        )
                                                                        .replace(
                                                                            /\}\}/g,
                                                                            "</u>"
                                                                        ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                            '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                                        ),
                                                                    }}
                                                                />
                                                                ) : (
                                                                ""
                                                                )}
                                                                {/* <div className="">{activityQuestion.english_question_part_text} </div> */}
                                                                
                                                                {activityQuestion &&
                                                                activityQuestion.question_answers &&
                                                                activityQuestion
                                                                    .question_answers
                                                                    .length > 0 &&
                                                                activityQuestion
                                                                    .question_answers[0]
                                                                    .english_answer_text &&
                                                                activityQuestion
                                                                    .question_answers[0]
                                                                    .english_answer_text !=
                                                                    "" &&
                                                                activityQuestion.question_answers.map(
                                                                    (
                                                                    activityQuestionAns,
                                                                    indexQuestionAns
                                                                    ) => (
                                                                    <div>
                                                                    <div
                                                                        className={
                                                                        activityQuestionAns &&
                                                                        activityQuestionAns.english_answer_text
                                                                            ? " myresult "
                                                                            : ""
                                                                        }
                                                                    >
                                                                        {/* <div className="p-2 px-3 px-3 font-size-18">{indexQuestionAns + 1}</div> */}
                                                                        
                                                                        <div
                                                                        className="p-2 px-3 dg-media input_box small_input_box question-answer-border"
                                                                        >
                                                                            {/* {small input box} */}
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                    )
                                                                )}
                                                            </div>
                                                            {/* </ul> */}
                                                            </>
                                                        )}
                                                    </>
                                                    )
                                                )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                            }else if(activity.subjectId == '2'){
                                return(
                                     
                                    <div className="hw-list mt-1 pb-50 w-100">
                                    {activity &&
                                    activity.question_details &&
                                    activity.question_details.question_text &&
                                    activity.question_details.question_text
                                        .trim()
                                        .toString() != "" ? (
                                        <div class="QuestionBody jss13 mb-5">
                                            <div className="d-flex align-items-start gap-4 justify-content-end">
                                                <div className="mb-0 d-flex align-items-center gap-2">
                                                    <h6 className="mb-0">
                                                        #
                                                        {activity.questionId
                                                        ? activity.questionId
                                                        : null}
                                                    </h6>
                                                </div>
                                            </div>
                                            <div>
                                                {" "}
                                                {activity.question_details &&
                                                activity.question_details.question_text ? (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                    __html:
                                                        activity.question_details.question_text
                                                        .replace(
                                                            /\[(\d+)Answer char=\d+\]/g,
                                                            ""
                                                        )
                                                        .replace(
                                                            /\[Answer char=\d+\]/g,
                                                            ""
                                                        ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                            '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                        ),
                                                    }}
                                                />
                                                ) : (
                                                ""
                                                )}{" "}
                                            </div>
                                        </div>
                                    ) : null}

                                    {activity &&
                                        activity.question_details &&
                                        activity.question_details.question_parts &&
                                        activity.question_details.question_parts.map(
                                        activityQuestion => (
                                            <>
                                            <div class="QuestionBody jss13 w-100">
                                                <div>
                                                {activityQuestion &&
                                                activityQuestion.part_text ? (
                                                    <div
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                        activityQuestion.part_text
                                                            .replace(
                                                            /\[(\d+)Answer char=\d+\]/g,
                                                            ""
                                                            )
                                                            .replace(
                                                            /\[Answer char=\d+\]/g,
                                                            ""
                                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                            ),
                                                    }}
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                                </div>
                                            </div>
                                            
                                            {activityQuestion &&
                                                activityQuestion.part_answer_type ==
                                                4 && (
                                                <ul className="dg-selector list-unstyled mb-0 pt-4 w-100">
                                                    {activityQuestion &&
                                                    activityQuestion.question_answers &&
                                                    (() => {
                                                        let serialNumber = 0 // Separate counter for serial number
                                                        return rearrangeEvenOdd(
                                                        activityQuestion.question_answers
                                                        ).map(
                                                        (
                                                            activityQuestionAns,
                                                            indexQuestionAns
                                                        ) => {
                                                            if (
                                                            activityQuestionAns &&
                                                            activityQuestionAns.answer_text
                                                            ) {
                                                            const cleanText = activityQuestionAns.answer_text
                                                            .replace(/&nbsp;/g, '')
                                                            .replace(/`/g, '')
                                                            .replace(/<[^>]*>/g, '')
                                                            .trim();
            
                                                                const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.answer_text);
                
                                                                if (!cleanText && !hasImage) {
                                                                    return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                }
            
                                                            serialNumber++ // Increment serial number only when answer text is valid

                                                            return (
                                                                <li
                                                                key={
                                                                    indexQuestionAns
                                                                }
                                                                className={"selector-display1"}
                                                                >
                                                                <div className="p-2 px-3 font-size-18">
                                                                    {
                                                                    serialNumber
                                                                    }
                                                                </div>
                                                                <div className="p-2 px-3 dg-media border-start-display">
                                                                    {activityQuestionAns &&
                                                                    activityQuestionAns.answer_text ? (
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                        __html:
                                                                            activityQuestionAns.answer_text,
                                                                        }}
                                                                    />
                                                                    ) : (
                                                                    ""
                                                                    )}
                                                                </div>
                                                                </li>
                                                            )
                                                            }

                                                            return null // Skip if answer_text is null
                                                        }
                                                        )
                                                    })()}
                                                </ul>
                                                )}
                                            {activityQuestion &&
                                                activityQuestion.part_answer_type ==
                                                2 && (
                                                    <div className="d-flex justify-content-end p-0 w-100">
                                                    <ul className="dg-selector list-unstyled mb-0 pt-4 w-25 ">
                                                        {activityQuestion &&
                                                        activityQuestion.question_answers &&
                                                        activityQuestion.question_answers.map(
                                                            (
                                                            activityQuestionAns,
                                                            indexQuestionAns
                                                            ) =>
                                                            activityQuestionAns &&
                                                            activityQuestionAns.answer_text ? (
                                                                <li className="">
                                                                <div className="p-2 px-3 dg-media question-answer-border custom-height w-100">
                                                                    
                                                                </div>
                                                                </li>
                                                            ) : null
                                                        )}
                                                    </ul>
                                                    </div>
                                                )}
                                            </>
                                        )
                                        )}

                                    
                                    </div>
                                                                    
                                )
                            }else{
                                return (null)
                            }
                           
                        }
                    }
                )}
            </div>
        </div>
    )
    : type === 'OnlineActivityPopup' ?
    (
        <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '795px',       // use viewport width
                height: 'auto',
                opacity: 0,
                pointerEvents: 'none',
                zIndex: -1,  
            }}>
            <div ref={contentRef} className="pdf-content" 
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    fontSize: '16px',
                    width: '100%',
                    maxWidth: '100%',
                    lineHeight: '1.4',
                    color: 'black' // Bark black or very dark black
                }}>
                <div className="d-flex align-items-center justify-content-between w-100 text-black">
                    <h6 className="mb-0 font-size-20 w-60 fw-500">
                    {ActivityData &&
                    ActivityData.activity_node &&
                    ActivityData.activity_node.node_name
                        ? ActivityData.activity_node.node_name
                        : ""}
                    </h6>
                    <div className="d-flex align-items-center gap-4">
                      <div className="font-size-16">
                        <img width={24} className="" src={awicon} alt="" /> 0 /{" "}
                        {ActivityData &&
                        ActivityData.english_question_activities &&
                        ActivityData.english_question_activities
                        .length > 0 &&
                        (parseInt(
                        ActivityData
                            .english_question_activities[0].english_question
                            .english_question_new_category
                            .english_question_category_id
                        ) === 13 ||
                        parseInt(
                            ActivityData
                            .english_question_activities[0].english_question
                            .english_question_new_category
                            .english_question_category_id
                        ) === 10)
                        ? ActivityData.english_question_activities.map(
                            (activity, popactivityindex) => {
                                let array_part_data = []
                                if (
                                activity.english_question &&
                                activity.english_question
                                    .english_question_new_category &&
                                (parseInt(
                                    activity.english_question
                                    .english_question_new_category
                                    .english_question_category_id
                                ) === 13 ||
                                    parseInt(
                                    activity.english_question
                                        .english_question_new_category
                                        .english_question_category_id
                                    ) === 10)
                                ) {
                                let total_part =
                                    activity.english_question
                                    .english_question_parts
                                array_part_data = total_part.filter(
                                    part =>
                                    part.english_question_answers.length >
                                        0 &&
                                    part.english_question_answers[0]
                                        .english_answer_text &&
                                    part.english_question_answers[0]
                                        .english_answer_text != ""
                                )
                                }
                                if (
                                ActivityData
                                    .english_question_activities.length ===
                                popactivityindex + 1
                                ) {
                                return array_part_data.length * 2 + " "
                                }
                            }
                            )
                        : ActivityData &&
                            ActivityData.totalScore
                        ? ActivityData.totalScore + " "
                        : ""}{" "}
                        coins earned
                      </div>
                    </div>
                </div>

               {/* stuject english */}
                {ActivityData &&
                ActivityData.english_question_activities &&
                ActivityData.english_question_activities.map(
                (activity, popactivityindex) => {
                    return (
                        <div className="hw-list mt-1 pb-50 w-100">
                            <div>
                            <div className={"QuestionBody jss13 mb-3  w-100"}>
                                <div>
                                <div className="d-flex align-items-start justify-content-end">
                                    <h6 className="me-2" style={{marginTop: '1.5px'}}>#{activity.english_question?.english_question_id || null}</h6>
                                </div>
                                <div
                                    className="mt-3"
                                    dangerouslySetInnerHTML={{
                                    __html:
                                        activity.english_question &&
                                        activity.english_question
                                        .english_question_instruction
                                        ? activity.english_question &&
                                            activity.english_question.english_question_instruction
                                            .replace(
                                                /\[(\d+)Answer char=\d+\]/g,
                                                ""
                                            )
                                            .replace(
                                                /\[Answer char=\d+\]/g,
                                                ""
                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                            )
                                        : null,
                                    }}
                                ></div>

                                {activity.english_question &&
                                activity.english_question
                                    .english_question_choices &&
                                activity.english_question
                                    .english_question_choices.length >
                                    0 ? (
                                    <div className="mt-3 my-2 border border-dark choice-options_wrapper">
                                    {activity.english_question.english_question_choices.map(
                                        (qusChoice, Cindex) => (
                                        <div
                                            class="choice-options_child"
                                            key={Cindex}
                                        >
                                            <div>
                                            {qusChoice.choice_no}
                                            </div>
                                            <div>
                                            {qusChoice.choice_text}
                                            </div>
                                        </div>
                                        )
                                    )}
                                    </div>
                                ) : null}

                                {activity.english_question &&
                                    activity.english_question
                                    .english_question_new_category &&
                                    activity.english_question
                                    .english_question_new_category
                                    .english_question_category_id ===
                                    1 &&
                                    (activity.english_question
                                    .english_question_text ? (
                                    <div
                                        className="mt-3"
                                        dangerouslySetInnerHTML={{
                                        __html:
                                            activity.english_question.english_question_text
                                            .replace(
                                                /\[(\d+)Answer char=\d+\]/g,
                                                ""
                                            )
                                            .replace(
                                                /\[Answer char=\d+\]/g,
                                                ""
                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                            ),
                                        }}
                                    />
                                    ) : null)}
                                {activity.english_question &&
                                    activity.english_question
                                    .english_question_new_category &&
                                    activity.english_question
                                    .english_question_new_category
                                    .english_question_category_id ===
                                    2 &&
                                    (activity.english_question
                                    .english_question_text ? (
                                    <div
                                        className="mt-3"
                                        dangerouslySetInnerHTML={{
                                        __html:
                                            activity.english_question.english_question_text
                                            .replace(
                                                /\[(\d+)Answer char=\d+\]/g,
                                                ""
                                            )
                                            .replace(
                                                /\[Answer char=\d+\]/g,
                                                ""
                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                            ),
                                        }}
                                    />
                                    ) : null)}
                                {activity.english_question &&
                                    activity.english_question
                                    .english_question_new_category &&
                                    activity.english_question
                                    .english_question_new_category
                                    .english_question_category_id ===
                                    8 &&
                                    (activity.english_question
                                    .english_question_text ? (
                                    <div
                                        className=""
                                        dangerouslySetInnerHTML={{
                                        __html: activity
                                            .english_question
                                            .english_question_text
                                            ? activity.english_question.english_question_text
                                                .replace(
                                                /\[(\d+)Answer char=\d+\]/g,
                                                ""
                                                )
                                                .replace(
                                                /\[Answer char=\d+\]/g,
                                                ""
                                                ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                    '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                )
                                                .replace(/&nbsp;/g, "")
                                               .replace(/(<br\s*\/?>\s*){3,}/gi, "<br>") 
                                                .split("</p>")
                                                .map(
                                                (paragraph, index) =>
                                                    paragraph
                                                    ? `<div class="mt-2 mb-1 font-size-18"><p>${
                                                        index + 1
                                                        } ${paragraph}</p></div>`
                                                    : ""
                                                )
                                                .filter(Boolean)
                                                .join("")
                                            : null,
                                        }}
                                    />
                                    ) : //  <div className="mt-3" dangerouslySetInnerHTML={{ __html: activity.english_question.english_question_text.replace(/\[(\d+)Answer char=\d+\]/g, '').replace(/\[Answer char=\d+\]/g, '') }} />
                                    null)}
                                {activity.english_question &&
                                    activity.english_question
                                    .english_question_new_category &&
                                    (parseInt(
                                    activity.english_question
                                        .english_question_new_category
                                        .english_question_category_id
                                    ) === 10 ||
                                    parseInt(
                                        activity.english_question
                                        .english_question_new_category
                                        .english_question_category_id
                                    ) === 13) &&
                                    (activity.english_question
                                    .english_question_text ? (
                                    <div
                                        className="mt-3"
                                        dangerouslySetInnerHTML={{
                                        __html:
                                            activity.english_question.english_question_text
                                            .replace(
                                                /\[(\d+)Answer char=\d+\]/g,
                                                ""
                                            )
                                            .replace(
                                                /\[Answer char=\d+\]/g,
                                                ""
                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                            ),
                                        }}
                                    />
                                    ) : null)}
                                {activity.english_question &&
                                    activity.english_question
                                    .english_question_new_category &&
                                    (parseInt(
                                    activity.english_question
                                        .english_question_new_category
                                        .english_question_category_id
                                    ) === 10 ||
                                    parseInt(
                                        activity.english_question
                                        .english_question_new_category
                                        .english_question_category_id
                                    ) === 13) &&
                                    (activity.english_question
                                    .part_heading ? (
                                    <div
                                        className="mt-3"
                                        dangerouslySetInnerHTML={{
                                        __html:
                                            activity.english_question.part_heading
                                            .replace(
                                                /\[(\d+)Answer char=\d+\]/g,
                                                ""
                                            )
                                            .replace(
                                                /\[Answer char=\d+\]/g,
                                                ""
                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                            ),
                                        }}
                                    />
                                    ) : null)}
                                </div>
                            </div>
                            <div>
                                {activity &&
                                activity.english_question &&
                                activity.english_question
                                .english_question_parts &&
                                activity.english_question
                                .english_question_parts &&
                                activity.english_question.english_question_parts.map(
                                (
                                    activityQuestion,
                                    indexactivityQuestion
                                ) => (
                                    <>

                                    {activity.english_question &&
                                        activity.english_question
                                        .english_question_new_category &&
                                        activity.english_question
                                        .english_question_new_category
                                        .english_question_category_id ==
                                        1 && (
                                        <ul className="dg-selector list-unstyled mb-0 pt-4">
                                            {activityQuestion &&
                                            activityQuestion.english_question_answers &&
                                            (() => {
                                                let serialNumber = 0 // Initialize a separate counter for serial numbers
                                                return rearrangeEvenOdd(
                                                activityQuestion.english_question_answers
                                                ).map(
                                                (
                                                    activityQuestionAns,
                                                    indexQuestionAns
                                                ) => {
                                                    if (
                                                    activityQuestionAns &&
                                                    activityQuestionAns.english_answer_text
                                                    ) {

                                                    const cleanText = activityQuestionAns.english_answer_text
                                                    .replace(/&nbsp;/g, '')
                                                    .replace(/`/g, '')
                                                    .replace(/<[^>]*>/g, '')
                                                    .trim();

                                                        const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.english_answer_text);
        
                                                        if (!cleanText && !hasImage) {
                                                            return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                        }
                                                    serialNumber++ // Increment serial number only when there's valid text

                                                    return (
                                                        <li
                                                        key={
                                                            indexQuestionAns
                                                        }
                                                        className={"selector-display1"}
                                                        >
                                                        <div className="p-2 px-3 font-size-18">
                                                            {
                                                            serialNumber
                                                            }
                                                        </div>
                                                        <div className="p-2 px-3 dg-media border-start-display">
                                                            <div
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                activityQuestionAns.english_answer_text,
                                                            }}
                                                            />
                                                        </div>
                                                        </li>
                                                    )
                                                    }

                                                    return null // Skip rendering if there's no answer text
                                                }
                                                )
                                            })()}
                                        </ul>
                                        )}

                                    {activity.english_question &&
                                        activity.english_question
                                        .english_question_new_category &&
                                        activity.english_question
                                        .english_question_new_category
                                        .english_question_category_id ==
                                        2 && (
                                        <>
                                            <div className="mr-3">
                                            {indexactivityQuestion +
                                                1}
                                            {")"}
                                            </div>
                                            <ul className="dg-selector list-unstyled mb-0 pt-2">
                                            {activityQuestion &&
                                                activityQuestion.english_question_answers &&
                                                (() => {
                                                let serialNumber = 0 // Separate counter for serial number
                                                const answers = activityQuestion.english_question_part_answer_type === 4
                                                                    ? rearrangeEvenOdd(activityQuestion.english_question_answers)
                                                                    : activityQuestion.english_question_answers || [];
                                                return answers.map(
                                                    (
                                                    activityQuestionAns2,
                                                    indexQuestionAns2
                                                    ) => {
                                                    if (
                                                        activityQuestionAns2 &&
                                                        activityQuestionAns2.english_answer_text
                                                    ) {

                                                        const cleanText = activityQuestionAns2.english_answer_text
                                                        .replace(/&nbsp;/g, '')
                                                        .replace(/`/g, '')
                                                        .replace(/<[^>]*>/g, '')
                                                        .trim();

                                                        const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns2.english_answer_text);
            
                                                        if (!cleanText && !hasImage) {
                                                            return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                        }
                                                        serialNumber++ // Increment serial number only if there's a valid answer text

                                                        return (
                                                        <li
                                                            key={
                                                            indexQuestionAns2
                                                            }
                                                            className={
                                                            "selector-display1"
                                                            }
                                                        >
                                                            {activityQuestion.english_question_part_answer_type === 4 ? 
                                                            <>
                                                            <div className="p-2 px-3 font-size-18">
                                                            {
                                                                serialNumber
                                                            }
                                                            </div> 
                                                            <div className="p-2 px-3 dg-media border-start-display">
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                __html:
                                                                    activityQuestionAns2.english_answer_text,
                                                                }}
                                                            />
                                                            </div>
                                                            </>
                                                            : 
                                                            <div className="p-2 px-3 dg-media border-start-display custom-height">
                                                            {/* {Input box} */}
                                                            </div>}
                                                        </li>
                                                        )
                                                    }

                                                    return null // Skip rendering if answer text is null
                                                    }
                                                )
                                                })()}
                                            </ul>
                                        </>
                                        )}

                                    {activity.english_question &&
                                        activity.english_question
                                        .english_question_new_category &&
                                        activity.english_question
                                        .english_question_new_category
                                        .english_question_category_id ==
                                        8 && (
                                        <>
                                            <div className="p-2 px-3 font-size-18 .no-break">
                                            {activityQuestion &&
                                            activityQuestion.english_question_part_text ? (
                                                <div
                                                dangerouslySetInnerHTML={{
                                                    __html: `${
                                                    indexactivityQuestion +
                                                    1
                                                    }) ${activityQuestion.english_question_part_text
                                                    .replace(
                                                        /\[(\d+)Answer char=\d+\]/g,
                                                        ""
                                                    )
                                                    .replace(
                                                        /\[Answer char=\d+\]/g,
                                                        ""
                                                    ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                        '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                    ).replace(/<img([^>]*?)>/gi, '<img style="width:170px;" $1>')}`,
                                                }}
                                                />
                                            ) : (
                                                ""
                                            )}
                                            </div>

                                            <ul className="dg-selector list-unstyled mb-0 pt-2">
                                            {activityQuestion &&
                                                activityQuestion.english_question_answers &&
                                                (() => {
                                                let serialNumber = 0 // Separate counter for serial number
                                                const answers = activityQuestion.english_question_part_answer_type === 4
                                                ? rearrangeEvenOdd(activityQuestion.english_question_answers)
                                                : activityQuestion.english_question_answers || [];
                                                // return rearrangeEvenOdd(
                                                //   activityQuestion.english_question_answers
                                                // ).map(
                                                    return answers.map((
                                                    activityQuestionAns,
                                                    indexQuestionAns
                                                    ) => {
                                                    if (
                                                        activityQuestionAns &&
                                                        activityQuestionAns.english_answer_text
                                                    ) {
                                                        const cleanText = activityQuestionAns.english_answer_text
                                                        .replace(/&nbsp;/g, '')
                                                        .replace(/`/g, '')
                                                        .replace(/<[^>]*>/g, '')
                                                        .trim();

                                                        const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.english_answer_text);
            
                                                        if (!cleanText && !hasImage) {
                                                            return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                        }
                                                        serialNumber++ // Increment serial number only if answer text is valid

                                                        return (
                                                        <li
                                                            key={
                                                            indexQuestionAns
                                                            }
                                                            className={"selector-display1"}>
                                                            {activityQuestion.english_question_part_answer_type === 4 ?
                                                            <>
                                                            <div className="p-2 px-3 font-size-18">
                                                            {
                                                                serialNumber
                                                            }
                                                            </div>
                                                            
                                                            <div className="p-2 px-3 dg-media border-start-display">
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                __html:
                                                                    activityQuestionAns.english_answer_text,
                                                                }}
                                                            />
                                                            </div>
                                                            </>
                                                            : 
                                                            <div className="p-2 px-3 dg-media border-start-display custom-height">
                                                            {/* {Input box} */}
                                                            </div>}
                                                        </li>
                                                        )
                                                    }

                                                    return null // Skip if answer text is null
                                                    }
                                                )
                                                })()}
                                            </ul>
                                        </>
                                        )}
                                  
                                    {activity.english_question &&
                                        activity.english_question
                                        .english_question_new_category &&
                                        (parseInt(
                                        activity.english_question
                                            .english_question_new_category
                                            .english_question_category_id
                                        ) === 13 ||
                                        parseInt(
                                            activity.english_question
                                            .english_question_new_category
                                            .english_question_category_id
                                        ) === 10) && (
                                        <>
                                            {/* <ul className="dg-selector list-unstyled mb-0 pt-4"> */}
                                            <div class="q_a-preview pt-3 d-flex justify-content-between align-items-center">
                                            {activityQuestion &&
                                            activityQuestion.english_question_part_text ? (
                                                <div
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                    activityQuestion.english_question_part_text
                                                        .replace(
                                                        /\[(\d+)Answer char=\d+\]/g,
                                                        ""
                                                        )
                                                        .replace(
                                                        /\[Answer char=\d+\]/g,
                                                        ""
                                                        )
                                                        .replace(
                                                        /\[\[(.+?)\]\]/g,
                                                        function (
                                                            match,
                                                            p1
                                                        ) {
                                                            return p1.length >
                                                            1
                                                            ? `<span class="text-bg-yellow">${p1}</span>`
                                                            : `<span class="text-bg-blue">${p1}</span>`
                                                        }
                                                        )
                                                        .replace(
                                                        /\{\{/g,
                                                        "<u>"
                                                        )
                                                        .replace(
                                                        /\}\}/g,
                                                        "</u>"
                                                        ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                            '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                                        ),
                                                }}
                                                />
                                            ) : (
                                                ""
                                            )}
                                            {/* <div className="">{activityQuestion.english_question_part_text} </div> */}
                                            
                                            {activityQuestion &&
                                                activityQuestion.english_question_answers &&
                                                activityQuestion
                                                .english_question_answers
                                                .length > 0 &&
                                                activityQuestion
                                                .english_question_answers[0]
                                                .english_answer_text &&
                                                activityQuestion
                                                .english_question_answers[0]
                                                .english_answer_text !=
                                                "" &&
                                                activityQuestion.english_question_answers.map(
                                                (
                                                    activityQuestionAns,
                                                    indexQuestionAns
                                                ) => (
                                                    <div>
                                                    <div
                                                    className={
                                                        activityQuestionAns &&
                                                        activityQuestionAns.english_answer_text
                                                        ? " myresult "
                                                        : ""
                                                    }
                                                    >
                                                    {/* <div className="p-2 px-3 px-3 font-size-18">{indexQuestionAns + 1}</div> */}
                                                    
                                                    <div
                                                        className="p-2 px-3 dg-media input_box small_input_box question-answer-border"
                                                    >
                                                        {/* small input box */}
                                                    </div>
                                                    </div>
                                                    </div>
                                                )
                                                )}
                                            </div>
                                            {/* </ul> */}
                                        </>
                                        )}
                                    </>
                                )
                                )}
                            </div>
                            </div>
                        </div>
                    )
                }
                )}
                {/* subject Maths */}
                {ActivityData &&
                ActivityData.question_activities &&
                ActivityData.question_activities.map(
                (activity, popactivityindex) => {
                   return ( 
                    <div className="hw-list mt-1 pb-50 w-100">
                        <div className="d-flex align-items-start justify-content-end">
                        <h6 className="me-2" style={{marginTop: '1.5px'}}>#{activity.question?.question_id || null}</h6>
                        
                        </div>
                        {activity &&
                        activity.question &&
                        activity.question.question_text &&
                        activity.question.question_text
                        .trim()
                        .toString() != "" ? (
                        <div class="QuestionBody jss13 mb-5">
                            <div>
                            {" "}
                            {activity.question &&
                            activity.question.question_text ? (
                                <div
                                dangerouslySetInnerHTML={{
                                    __html:
                                    activity.question.question_text
                                        .replace(
                                        /\[(\d+)Answer char=\d+\]/g,
                                        ""
                                        )
                                        .replace(
                                        /\[Answer char=\d+\]/g,
                                        ""
                                        ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                            '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                        ),
                                }}
                                />
                            ) : (
                                ""
                            )}{" "}
                            </div>
                        </div>
                        ) : null}

                        {activity &&
                        activity.question &&
                        activity.question.question_parts &&
                        activity.question.question_parts &&
                        activity.question.question_parts.map(
                            activityQuestion => (
                            <>
                                <div class="QuestionBody jss13">
                                <div>
                                    {activityQuestion &&
                                    activityQuestion.part_text ? (
                                    <div
                                        dangerouslySetInnerHTML={{
                                        __html:
                                            activityQuestion.part_text
                                            .replace(
                                                /\[(\d+)Answer char=\d+\]/g,
                                                ""
                                            )
                                            .replace(
                                                /\[Answer char=\d+\]/g,
                                                ""
                                            ).replace(/<u>(&nbsp;|\s|<br>)*<\/u>/gi, 
                                                '<span style="display:inline-block;border-bottom:1px solid black;width:300px;"></span>'
                                            ),
                                        }}
                                    />
                                    ) : (
                                    ""
                                    )}
                                </div>
                                </div>
                               
                                {activityQuestion &&
                                activityQuestion.part_answer_type ==
                                    4 && (
                                    <ul className="dg-selector list-unstyled mb-0 pt-4">
                                    {activityQuestion &&
                                        activityQuestion.question_answers &&
                                        (() => {
                                        let serialNumber = 0 // Separate counter for serial number
                                        return rearrangeEvenOdd(
                                            activityQuestion.question_answers
                                        ).map(
                                            (
                                            activityQuestionAns,
                                            indexQuestionAns
                                            ) => {
                                            if (
                                                activityQuestionAns &&
                                                activityQuestionAns.answer_text
                                            ) {
                                                const cleanText = activityQuestionAns.answer_text
                                                .replace(/&nbsp;/g, '')
                                                .replace(/`/g, '')
                                                .replace(/<[^>]*>/g, '')
                                                .trim();

                                                const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.answer_text);
    
                                                if (!cleanText && !hasImage) {
                                                    return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                }

                                                serialNumber++ // Increment serial number only when answer text is valid

                                                return (
                                                <li
                                                    key={
                                                    indexQuestionAns
                                                    }
                                                    className={"selector-display1"}
                                                >
                                                    <div className="p-2 px-3 font-size-18">
                                                    {
                                                        serialNumber
                                                    }
                                                    </div>
                                                    <div className="p-2 px-3 dg-media border-start-display">
                                                    {activityQuestionAns &&
                                                    activityQuestionAns.answer_text ? (
                                                        <div
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                            activityQuestionAns.answer_text,
                                                        }}
                                                        />
                                                    ) : (
                                                        ""
                                                    )}
                                                    </div>
                                                </li>
                                                )
                                            }

                                            return null // Skip if answer_text is null
                                            }
                                        )
                                        })()}
                                    </ul>
                                )}
                                {activityQuestion &&
                                activityQuestion.part_answer_type ==
                                    2 && (
                                    <div className="d-flex justify-content-end p-0">
                                    <ul className="dg-selector list-unstyled mb-0 pt-4 w-25 ">
                                    {activityQuestion &&
                                        activityQuestion.question_answers &&
                                        activityQuestion.question_answers.map(
                                        (
                                            activityQuestionAns,
                                            indexQuestionAns
                                        ) =>
                                            activityQuestionAns &&
                                            activityQuestionAns.answer_text ? (
                                            <li className="">
                                                <div className="p-2 px-3 dg-media question-answer-border custom-height w-100">
                                                    {/* input box small */}
                                                </div>
                                            </li>
                                            ) : null
                                        )}
                                    </ul>
                                    </div>
                                )}
                            </>
                            )
                        )}

                    </div>
                   )
                   
                }
                )}
            </div>
        </div>
    ) : (null)

  
});

export default ActivityToPDFConverter;
